import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Heading,
  Text,
  Card,
  CardBody,
  VStack,
  HStack,
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  Select,
  Textarea,
  useToast,
  Badge,
  IconButton,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Spinner,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useBreakpointValue,
  Checkbox,
  CheckboxGroup,
  Image,
  Divider,
} from '@chakra-ui/react';
import DataTable from 'react-data-table-component';
import { FiEdit, FiTrash2, FiPlus, FiRefreshCw, FiEye, FiImage, FiHome } from 'react-icons/fi';
import { hotelApi, hotelImageApi, hotelRoomTypeApi, loungeApi, loungeImageApi, conciergeApi, conciergeImageApi, baggageApi, baggageImageApi, airportApi } from '../config/api';
import { useAuth } from '../context/AuthContext';
import IeemPublishTab from '../components/IeemPublishTab';
import IeemFlyerTab from '../components/IeemFlyerTab';
import IeemIframeTab from '../components/IeemIframeTab';
import BundlingProductTab from '../components/BundlingProductTab';
import ProductWrappingTab from '../components/ProductWrappingTab';
import PageHeader from '../components/bundling/PageHeader';
import IasIntegrationData from './IasIntegrationData';

const AviationServices = () => {
  const [hotels, setHotels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingHotel, setEditingHotel] = useState(null);
  const [viewingHotel, setViewingHotel] = useState(null);
  const [deleteHotel, setDeleteHotel] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  // Helper function to format number to Rupiah
  const formatRupiah = (value) => {
    if (!value || value === '' || isNaN(Number(value))) return value;
    return new Intl.NumberFormat('id-ID', { 
      style: 'currency', 
      currency: 'IDR', 
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(Number(value));
  };
  
  // Hotel Image states
  const [managingImagesHotel, setManagingImagesHotel] = useState(null);
  const [hotelImages, setHotelImages] = useState([]);
  const [loadingImages, setLoadingImages] = useState(false);
  const [uploadingImage, setUploadingImage] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({});
  const [deleteImage, setDeleteImage] = useState(null);
  
  // Hotel Room Types states
  const [roomTypes, setRoomTypes] = useState([]);
  const [loadingRoomTypes, setLoadingRoomTypes] = useState(false);
  const [editingRoomType, setEditingRoomType] = useState(null);
  const [deleteRoomType, setDeleteRoomType] = useState(null);
  const { isOpen: isRoomTypeFormOpen, onOpen: onRoomTypeFormOpen, onClose: onRoomTypeFormClose } = useDisclosure();
  const { isOpen: isDeleteRoomTypeOpen, onOpen: onDeleteRoomTypeOpen, onClose: onDeleteRoomTypeClose } = useDisclosure();
  const [roomTypeFormData, setRoomTypeFormData] = useState({
    ROOMTYPE_CODE: '',
    ROOMTYPE_NAME: '',
    ROOMTYPE_BASEOCCUPANCY: '',
    ROOMTYPE_MAXOCCUPANCY: '',
    ROOMTYPE_DESCRIPTION: '',
    ROOMTYPE_DISCOUNTPRICE: '',
    ROOMTYPE_FIXEDPRICE: '',
  });
  
  // Lounge states
  const [lounges, setLounges] = useState([]);
  const [loadingLounges, setLoadingLounges] = useState(false);
  const [editingLounge, setEditingLounge] = useState(null);
  const [viewingLounge, setViewingLounge] = useState(null);
  const [deleteLounge, setDeleteLounge] = useState(null);
  const [searchTermLounge, setSearchTermLounge] = useState('');
  
  // Airport states
  const [airports, setAirports] = useState([]);
  const [loadingAirports, setLoadingAirports] = useState(false);
  const [airportSearchTerm, setAirportSearchTerm] = useState('');
  const [isAirportDropdownOpen, setIsAirportDropdownOpen] = useState(false);
  
  // Lounge Image states
  const [managingImagesLounge, setManagingImagesLounge] = useState(null);
  const [loungeImages, setLoungeImages] = useState([]);
  const [loadingLoungeImages, setLoadingLoungeImages] = useState(false);
  const [uploadingLoungeImage, setUploadingLoungeImage] = useState(false);
  const [deleteLoungeImage, setDeleteLoungeImage] = useState(null);
  
  // Concierge states
  const [concierges, setConcierges] = useState([]);
  const [loadingConcierges, setLoadingConcierges] = useState(false);
  const [editingConcierge, setEditingConcierge] = useState(null);
  const [viewingConcierge, setViewingConcierge] = useState(null);
  const [deleteConcierge, setDeleteConcierge] = useState(null);
  const [searchTermConcierge, setSearchTermConcierge] = useState('');
  
  // Concierge Image states
  const [managingImagesConcierge, setManagingImagesConcierge] = useState(null);
  const [conciergeImages, setConciergeImages] = useState([]);
  const [loadingConciergeImages, setLoadingConciergeImages] = useState(false);
  const [uploadingConciergeImage, setUploadingConciergeImage] = useState(false);
  const [deleteConciergeImage, setDeleteConciergeImage] = useState(null);
  
  // Baggage states
  const [baggages, setBaggages] = useState([]);
  const [loadingBaggages, setLoadingBaggages] = useState(false);
  const [editingBaggage, setEditingBaggage] = useState(null);
  const [viewingBaggage, setViewingBaggage] = useState(null);
  const [deleteBaggage, setDeleteBaggage] = useState(null);
  const [searchTermBaggage, setSearchTermBaggage] = useState('');
  
  // Baggage Image states
  const [managingImagesBaggage, setManagingImagesBaggage] = useState(null);
  const [baggageImages, setBaggageImages] = useState([]);
  const [loadingBaggageImages, setLoadingBaggageImages] = useState(false);
  const [uploadingBaggageImage, setUploadingBaggageImage] = useState(false);
  const [deleteBaggageImage, setDeleteBaggageImage] = useState(null);
  
  const location = useLocation();
  const navigate = useNavigate();
  const toast = useToast();
  const { selectedRole, user } = useAuth();
  
  // Determine active tab based on route - hanya untuk IEEM sub menu
  const isIeemRoute = location.pathname.includes('/aviation-services/ieem') || location.pathname === '/admin/aviation-services/ieem';
  const isBundlingProductRoute = location.pathname.includes('/aviation-services/bundling-product') || location.pathname === '/admin/aviation-services/bundling-product';
  const isIntegrationDataRoute = location.pathname.includes('/aviation-services/integrationData');
  
  // Tab hanya untuk IEEM: How to Publish dan List Product
  const [activeIeemTab, setActiveIeemTab] = useState(0);
  const [importedProductDraft, setImportedProductDraft] = useState(null);
  
  // Update active tab when route changes
  useEffect(() => {
    if (location.pathname === '/admin/aviation-services/ieem' || location.pathname === '/admin/aviation-services') {
      // Default redirect to IEEM if no sub route specified
      navigate('/admin/aviation-services/ieem', { replace: true });
    }
  }, [location.pathname, navigate]);

  useEffect(() => {
    const sourceProduct = location.state?.importedIasProduct;
    if (!sourceProduct) return;

    setImportedProductDraft(sourceProduct);
    navigate(location.pathname, { replace: true, state: {} });
  }, [location.pathname, location.state, navigate]);

  // Check user role
  const userRole = user?.role || '';
  let parsedUserRoles = [];
  if (userRole) {
    if (Array.isArray(userRole)) {
      parsedUserRoles = userRole;
    } else if (typeof userRole === 'string') {
      if (userRole.includes(';')) {
        parsedUserRoles = userRole.split(';').map(r => r.trim()).filter(r => r);
      } else if (userRole.includes(',')) {
        parsedUserRoles = userRole.split(',').map(r => r.trim()).filter(r => r);
      } else if (userRole.trim()) {
        parsedUserRoles = [userRole.trim()];
      }
    }
  }
  
  const hasRoleIeem = selectedRole === 'ieem' || (!selectedRole && parsedUserRoles.includes('ieem'));
  const hasRoleBp = selectedRole === 'bp' || (!selectedRole && parsedUserRoles.includes('bp'));

  // Mapping IEMMPUBLISH_MEMBER - always 'ias' for Aviation Services
  const getMemberCode = useCallback(() => 'ias', []);

  const handleImportProductFromIas = useCallback((product) => {
    setImportedProductDraft(product);
    navigate('/admin/aviation-services/bundling-product', {
      state: { importedIasProduct: product },
    });
  }, [navigate]);

  const handleImportedProductConsumed = useCallback(() => {
    setImportedProductDraft(null);
  }, []);

  const { isOpen: isFormOpen, onOpen: onFormOpen, onClose: onFormClose } = useDisclosure();
  const { isOpen: isViewOpen, onOpen: onViewOpen, onClose: onViewClose } = useDisclosure();
  const { isOpen: isDeleteOpen, onOpen: onDeleteOpen, onClose: onDeleteClose } = useDisclosure();
  const { isOpen: isImagesOpen, onOpen: onImagesOpen, onClose: onImagesClose } = useDisclosure();
  const { isOpen: isDeleteImageOpen, onOpen: onDeleteImageOpen, onClose: onDeleteImageClose } = useDisclosure();
  
  // Lounge modals
  const { isOpen: isLoungeFormOpen, onOpen: onLoungeFormOpen, onClose: onLoungeFormClose } = useDisclosure();
  const { isOpen: isLoungeViewOpen, onOpen: onLoungeViewOpen, onClose: onLoungeViewClose } = useDisclosure();
  const { isOpen: isLoungeDeleteOpen, onOpen: onLoungeDeleteOpen, onClose: onLoungeDeleteClose } = useDisclosure();
  const { isOpen: isLoungeImagesOpen, onOpen: onLoungeImagesOpen, onClose: onLoungeImagesClose } = useDisclosure();
  const { isOpen: isDeleteLoungeImageOpen, onOpen: onDeleteLoungeImageOpen, onClose: onDeleteLoungeImageClose } = useDisclosure();
  
  // Concierge modals
  const { isOpen: isConciergeFormOpen, onOpen: onConciergeFormOpen, onClose: onConciergeFormClose } = useDisclosure();
  const { isOpen: isConciergeViewOpen, onOpen: onConciergeViewOpen, onClose: onConciergeViewClose } = useDisclosure();
  const { isOpen: isConciergeDeleteOpen, onOpen: onConciergeDeleteOpen, onClose: onConciergeDeleteClose } = useDisclosure();
  const { isOpen: isConciergeImagesOpen, onOpen: onConciergeImagesOpen, onClose: onConciergeImagesClose } = useDisclosure();
  const { isOpen: isDeleteConciergeImageOpen, onOpen: onDeleteConciergeImageOpen, onClose: onDeleteConciergeImageClose } = useDisclosure();
  
  // Baggage modals
  const { isOpen: isBaggageFormOpen, onOpen: onBaggageFormOpen, onClose: onBaggageFormClose } = useDisclosure();
  const { isOpen: isBaggageViewOpen, onOpen: onBaggageViewOpen, onClose: onBaggageViewClose } = useDisclosure();
  const { isOpen: isBaggageDeleteOpen, onOpen: onBaggageDeleteOpen, onClose: onBaggageDeleteClose } = useDisclosure();
  const { isOpen: isBaggageImagesOpen, onOpen: onBaggageImagesOpen, onClose: onBaggageImagesClose } = useDisclosure();
  const { isOpen: isDeleteBaggageImageOpen, onOpen: onDeleteBaggageImageOpen, onClose: onDeleteBaggageImageClose } = useDisclosure();
  
  const cancelRef = React.useRef();
  const cancelImageRef = React.useRef();
  const cancelLoungeRef = React.useRef();
  const cancelLoungeImageRef = React.useRef();
  const cancelConciergeRef = React.useRef();
  const cancelConciergeImageRef = React.useRef();
  const cancelBaggageRef = React.useRef();
  const cancelBaggageImageRef = React.useRef();

  const [formData, setFormData] = useState({
    HOTEL_NAME: '',
    HOTEL_STAR: '',
    HOTEL_LOCATION: '',
    HOTEL_DESCRIPTION: '',
    HOTEL_ROOMOPTION: [],
    HOTEL_DISCOUNT: '',
    HOTEL_FIXEDPRICE: '',
    HOTEL_PUBLISHRATE: '0',
    HOTEL_CONTACTPERSON: '',
    HOTEL_PHONE: '',
    HOTEL_EMAIL: '',
    HOTEL_TERMCONDITION: '',
    HOTEL_MSG: '',
    HOTEL_BOOKINGURL: '',
    HOTEL_STATUS: '1',
  });
  
  const [loungeFormData, setLoungeFormData] = useState({
    LOUNGE_NAME: '',
    LOUNGE_CITY: '',
    LOUNGE_TERMINAL: '',
    AIRPORT_CODE: '',
    LOUNGE_PUBLISRATE: '0',
    LOUNGE_PRICE: '',
    LOUNGE_DISCOUNTPRICE: '',
    LOUNGE_PHONE: '',
    LOUNGE_CONTACTPERSON: '',
    LOUNGE_EMAIL: '',
    LOUNGE_TERMCONDITION: '',
    LOUNGE_MSG: '',
    LOUNGE_STATUS: '1',
    LOUNGE_DESCRIPTION: '',
  });
  
  const [conciergeFormData, setConciergeFormData] = useState({
    CONCIERGE_NAME: '',
    CONCIERGE_TYPE: '',
    CONCIERGE_LOCATION: '',
    CONCIERGE_SERVICES: '',
    CONCIERGE_DESCRIPTION: '',
    CONCIERGE_PUBLISHRATE: '0',
    CONCIERGE_PRICE: '',
    CONCIERGE_DISCOUNTPRICE: '',
    CONCIERGE_PHONE: '',
    CONCIERGE_CONTACTPERSON: '',
    CONCIERGE_EMAIL: '',
    CONCIERGE_TERMCONDITION: '',
    CONCIERGE_MSG: '',
    CONCIERGE_STATUS: '1',
    AIRPORT_CODE: '',
    ROUTES_TYPE: '',
    FLIGHT_TYPE: '',
    ROUTES_TYPETO: '',
  });
  
  const [baggageFormData, setBaggageFormData] = useState({
    BAGGAGE_NAME: '',
    BAGGAGE_LOCATION: '',
    BAGGAGE_AREA: '',
    BAGGAGE_DESCRIPTION: '',
    BAGGAGE_PUBLISHRATE: '0',
    BAGGAGE_PRICE: '',
    BAGGAGE_DISCOUNTPRICE: '',
    BAGGAGE_PHONE: '',
    BAGGAGE_CONTACTPERSON: '',
    BAGGAGE_EMAIL: '',
    BAGGAGE_TERMCONDITION: '',
    BAGGAGE_MSG: '',
    BAGGAGE_STATUS: '1',
  });

  // Room Option options
  const roomOptions = [
    'Standart Room',
    'Deluxe Room',
    'Suite Room',
    'Executive Room',
    'Presidential Suite',
    'Junior Suite',
    'Deluxe Difable',
    'Deluxe King / Twin Room',
    'Deluxe Suite',
    'Family Room',
    'Twin Room',
    'Single Room',
    'Triple Room',
    'Villa / Cottage / Bungalow',
  ];

  const fetchHotels = useCallback(async () => {
    setLoading(true);
    try {
      // Gunakan endpoint /list dengan filter memberId = 'ias' untuk Aviation Services
      // includeInactive=true untuk menampilkan semua data termasuk non-active (untuk admin)
      const memberId = getMemberCode(); // Returns 'ias' for aviation services
      const response = await hotelApi.get('/list', {
        params: { 
          memberId,
          includeInactive: true // Show all statuses including non-active for admin
        }
      });
      if (response.data.status === 200) {
        const hotelsData = response.data.data || [];
        setHotels(hotelsData);
      } else {
        toast({
          title: 'Error',
          description: response.data.message || 'Gagal mengambil data hotel',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error('Error fetching hotels:', error);
      console.error('Error response:', error.response?.data);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat mengambil data',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  }, [toast, getMemberCode]);

  useEffect(() => {
    // Fetch hotels jika di tab List Product (hanya untuk IEEM route)
    if (hasRoleIeem && isIeemRoute && activeIeemTab === 1) {
      fetchHotels();
    }
  }, [fetchHotels, hasRoleIeem, isIeemRoute, activeIeemTab]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle room option change
  const handleRoomOptionChange = (selectedOptions) => {
    setFormData((prev) => ({
      ...prev,
      HOTEL_ROOMOPTION: selectedOptions,
    }));
  };

  const handleCreate = () => {
    setEditingHotel(null);
    setFormData({
      HOTEL_NAME: '',
      HOTEL_STAR: '',
      HOTEL_LOCATION: '',
      HOTEL_DESCRIPTION: '',
      HOTEL_ROOMOPTION: [],
      HOTEL_DISCOUNT: '',
      HOTEL_FIXEDPRICE: '',
      HOTEL_PUBLISHRATE: '0',
      HOTEL_CONTACTPERSON: '',
      HOTEL_PHONE: '',
      HOTEL_EMAIL: '',
      HOTEL_TERMCONDITION: '',
      HOTEL_MSG: '',
      HOTEL_BOOKINGURL: '',
      HOTEL_STATUS: '1',
    });
    onFormOpen();
  };

  const handleEdit = async (hotel) => {
    setEditingHotel(hotel);
    // Fetch room types for this hotel
    if (hotel.HOTEL_ID) {
      await fetchRoomTypes(hotel.HOTEL_ID);
    }
    // Parse HOTEL_ROOMOPTION dari string ke array
    let roomOptionArray = [];
    if (hotel.HOTEL_ROOMOPTION) {
      if (Array.isArray(hotel.HOTEL_ROOMOPTION)) {
        roomOptionArray = hotel.HOTEL_ROOMOPTION;
      } else if (typeof hotel.HOTEL_ROOMOPTION === 'string') {
        // Support comma atau semicolon separator
        if (hotel.HOTEL_ROOMOPTION.includes(';')) {
          roomOptionArray = hotel.HOTEL_ROOMOPTION.split(';').map(r => r.trim()).filter(r => r);
        } else if (hotel.HOTEL_ROOMOPTION.includes(',')) {
          roomOptionArray = hotel.HOTEL_ROOMOPTION.split(',').map(r => r.trim()).filter(r => r);
        } else if (hotel.HOTEL_ROOMOPTION.trim()) {
          roomOptionArray = [hotel.HOTEL_ROOMOPTION.trim()];
        }
      }
    }
    
    setFormData({
      HOTEL_NAME: hotel.HOTEL_NAME || '',
      HOTEL_STAR: hotel.HOTEL_STAR?.toString() || '',
      HOTEL_LOCATION: hotel.HOTEL_LOCATION || '',
      HOTEL_DESCRIPTION: hotel.HOTEL_DESCRIPTION || '',
      HOTEL_ROOMOPTION: roomOptionArray,
      HOTEL_DISCOUNT: hotel.HOTEL_DISCOUNT || '',
      HOTEL_FIXEDPRICE: hotel.HOTEL_FIXEDPRICE || '',
      HOTEL_PUBLISHRATE: hotel.HOTEL_PUBLISHRATE?.toString() || '0',
      HOTEL_CONTACTPERSON: hotel.HOTEL_CONTACTPERSON || '',
      HOTEL_PHONE: hotel.HOTEL_PHONE || '',
      HOTEL_EMAIL: hotel.HOTEL_EMAIL || '',
      HOTEL_TERMCONDITION: hotel.HOTEL_TERMCONDITION || '',
      HOTEL_MSG: hotel.HOTEL_MSG || '',
      HOTEL_BOOKINGURL: hotel.HOTEL_BOOKINGURL || '',
      HOTEL_STATUS: hotel.HOTEL_STATUS?.toString() || '1',
    });
    onFormOpen();
  };

  const handleSubmit = async () => {
    // Validasi required fields sesuai controller
    if (!formData.HOTEL_NAME || !formData.HOTEL_STAR || !formData.HOTEL_LOCATION) {
      toast({
        title: 'Validasi gagal',
        description: 'Nama hotel, bintang, dan lokasi harus diisi',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      // Prepare data dengan HOTEL_ROOMOPTION sebagai string (semicolon separated)
      const submitData = {
        ...formData,
        HOTEL_ROOMOPTION: Array.isArray(formData.HOTEL_ROOMOPTION) && formData.HOTEL_ROOMOPTION.length > 0
          ? formData.HOTEL_ROOMOPTION.join(';')
          : (formData.HOTEL_ROOMOPTION || null),
      };

      // Add MEMBER_ID to submit data - always 'ias' for Aviation Services
      const memberId = getMemberCode(); // Returns 'ias' for aviation services
      const finalSubmitData = {
        ...submitData,
        MEMBER_ID: memberId
      };

      if (editingHotel) {
        // Update - menggunakan POST /update/:id
        const response = await hotelApi.post(`/update/${editingHotel.HOTEL_ID}`, finalSubmitData);
        if (response.data.status === 200) {
          toast({
            title: 'Berhasil',
            description: 'Hotel berhasil diupdate',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
          onFormClose();
          fetchHotels();
        }
      } else {
        // Create - menggunakan POST /
        const response = await hotelApi.post('/', finalSubmitData);
        if (response.data.status === 201 || response.data.status === 200) {
          toast({
            title: 'Berhasil',
            description: 'Hotel berhasil dibuat',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
          onFormClose();
          fetchHotels();
        }
      }
    } catch (error) {
      console.error('Error saving hotel:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat menyimpan data',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleView = async (hotel) => {
    setViewingHotel(hotel);
    onViewOpen();
    // Fetch room types for this hotel
    if (hotel.HOTEL_ID) {
      await fetchRoomTypes(hotel.HOTEL_ID);
    }
  };
  
  // Room Types Functions
  const fetchRoomTypes = async (hotelId) => {
    try {
      setLoadingRoomTypes(true);
      const response = await hotelRoomTypeApi.get(`/hotel/${hotelId}`);
      if (response.data.status === 200) {
        setRoomTypes(response.data.data || []);
      }
    } catch (error) {
      console.error('Error fetching room types:', error);
      setRoomTypes([]);
    } finally {
      setLoadingRoomTypes(false);
    }
  };
  
  const handleCreateRoomType = async (hotel = null) => {
    // Prioritize: passed hotel parameter > viewingHotel > editingHotel
    let targetHotel = hotel;
    
    // If no hotel parameter passed, use viewingHotel if available, otherwise editingHotel
    if (!targetHotel) {
      if (viewingHotel) {
        targetHotel = viewingHotel;
      } else if (editingHotel) {
        targetHotel = editingHotel;
      }
    }
    
    if (!targetHotel) {
      toast({
        title: 'Error',
        description: 'Pilih hotel terlebih dahulu',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    
    // Get hotel ID - handle both string and number, try multiple property names
    let hotelId = targetHotel.HOTEL_ID || targetHotel.hotel_id || targetHotel.id || targetHotel.HOTEL_ID;
    
    // If still not found, log for debugging
    if (!hotelId && hotelId !== 0) {
      console.error('Hotel object:', targetHotel);
      console.error('Available keys:', Object.keys(targetHotel));
      console.error('viewingHotel:', viewingHotel);
      console.error('editingHotel:', editingHotel);
      
      toast({
        title: 'Error',
        description: 'Hotel ID tidak ditemukan. Silakan coba lagi atau refresh halaman.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      return;
    }
    
    // Convert to number if it's a string representation of a number
    const numericHotelId = typeof hotelId === 'string' ? parseInt(hotelId, 10) : Number(hotelId);
    
    if (isNaN(numericHotelId)) {
      console.error('Invalid hotel ID:', hotelId);
      toast({
        title: 'Error',
        description: 'Hotel ID tidak valid',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    
    // Set hotel for room type management
    setEditingHotel(targetHotel);
    
    // Fetch room types first
    await fetchRoomTypes(numericHotelId);
    // Reset form for new room type
    setEditingRoomType(null);
    setRoomTypeFormData({
      ROOMTYPE_CODE: '',
      ROOMTYPE_NAME: '',
      ROOMTYPE_BASEOCCUPANCY: '',
      ROOMTYPE_MAXOCCUPANCY: '',
      ROOMTYPE_DESCRIPTION: '',
      ROOMTYPE_DISCOUNTPRICE: '',
      ROOMTYPE_FIXEDPRICE: '',
    });
    onRoomTypeFormOpen();
  };
  
  const handleEditRoomType = (roomType) => {
    setEditingRoomType(roomType);
    setRoomTypeFormData({
      ROOMTYPE_CODE: roomType.ROOMTYPE_CODE || '',
      ROOMTYPE_NAME: roomType.ROOMTYPE_NAME || '',
      ROOMTYPE_BASEOCCUPANCY: roomType.ROOMTYPE_BASEOCCUPANCY?.toString() || '',
      ROOMTYPE_MAXOCCUPANCY: roomType.ROOMTYPE_MAXOCCUPANCY?.toString() || '',
      ROOMTYPE_DESCRIPTION: roomType.ROOMTYPE_DESCRIPTION || '',
      ROOMTYPE_DISCOUNTPRICE: roomType.ROOMTYPE_DISCOUNTPRICE || '',
      ROOMTYPE_FIXEDPRICE: roomType.ROOMTYPE_FIXEDPRICE || '',
    });
    onRoomTypeFormOpen();
  };
  
  const handleSubmitRoomType = async () => {
    if (!roomTypeFormData.ROOMTYPE_NAME || roomTypeFormData.ROOMTYPE_NAME.trim() === '') {
      toast({
        title: 'Validasi gagal',
        description: 'Nama room type harus diisi',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    
    const hotelId = editingHotel?.HOTEL_ID || viewingHotel?.HOTEL_ID;
    if (!hotelId) {
      toast({
        title: 'Error',
        description: 'Hotel ID tidak ditemukan',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    
    try {
      if (editingRoomType) {
        // Update
        const response = await hotelRoomTypeApi.post(`/update/${editingRoomType.ROOMTYPE_ID}`, {
          ...roomTypeFormData,
          ROOMTYPE_BASEOCCUPANCY: roomTypeFormData.ROOMTYPE_BASEOCCUPANCY ? parseInt(roomTypeFormData.ROOMTYPE_BASEOCCUPANCY) : null,
          ROOMTYPE_MAXOCCUPANCY: roomTypeFormData.ROOMTYPE_MAXOCCUPANCY ? parseInt(roomTypeFormData.ROOMTYPE_MAXOCCUPANCY) : null,
        });
        if (response.data.status === 200) {
          toast({
            title: 'Berhasil',
            description: 'Room type berhasil diupdate',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
          onRoomTypeFormClose();
          await fetchRoomTypes(hotelId);
        }
      } else {
        // Create
        const response = await hotelRoomTypeApi.post('/', {
          HOTEL_ID: hotelId,
          ...roomTypeFormData,
          ROOMTYPE_BASEOCCUPANCY: roomTypeFormData.ROOMTYPE_BASEOCCUPANCY ? parseInt(roomTypeFormData.ROOMTYPE_BASEOCCUPANCY) : null,
          ROOMTYPE_MAXOCCUPANCY: roomTypeFormData.ROOMTYPE_MAXOCCUPANCY ? parseInt(roomTypeFormData.ROOMTYPE_MAXOCCUPANCY) : null,
        });
        if (response.data.status === 201) {
          toast({
            title: 'Berhasil',
            description: 'Room type berhasil dibuat',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
          onRoomTypeFormClose();
          await fetchRoomTypes(hotelId);
        }
      }
    } catch (error) {
      console.error('Error saving room type:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat menyimpan data',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };
  
  const handleDeleteRoomTypeClick = (roomType) => {
    setDeleteRoomType(roomType);
    onDeleteRoomTypeOpen();
  };
  
  const handleDeleteRoomTypeConfirm = async () => {
    if (!deleteRoomType) return;
    
    try {
      const response = await hotelRoomTypeApi.post(`/delete/${deleteRoomType.ROOMTYPE_ID}`);
      if (response.data.status === 200) {
        toast({
          title: 'Berhasil',
          description: 'Room type berhasil dihapus',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        onDeleteRoomTypeClose();
        setDeleteRoomType(null);
        const hotelId = editingHotel?.HOTEL_ID || viewingHotel?.HOTEL_ID;
        if (hotelId) {
          await fetchRoomTypes(hotelId);
        }
      }
    } catch (error) {
      console.error('Error deleting room type:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat menghapus data',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleDeleteClick = (hotel) => {
    setDeleteHotel(hotel);
    onDeleteOpen();
  };

  const handleDeleteConfirm = async () => {
    if (!deleteHotel) return;

    try {
      // Delete - menggunakan POST /delete/:id (soft delete)
      const response = await hotelApi.post(`/delete/${deleteHotel.HOTEL_ID}`);
      if (response.data.status === 200) {
        toast({
          title: 'Berhasil',
          description: response.data.message || 'Hotel berhasil dihapus (status diubah menjadi not active)',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        onDeleteClose();
        setDeleteHotel(null);
        fetchHotels();
      }
    } catch (error) {
      console.error('Error deleting hotel:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat menghapus data',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Hotel Image handlers
  const handleManageImages = async (hotel) => {
    if (!hotel || !hotel.HOTEL_ID) {
      toast({
        title: 'Error',
        description: 'Data hotel tidak valid',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    setManagingImagesHotel(hotel);
    onImagesOpen();
    await fetchHotelImages(hotel.HOTEL_ID);
  };

  const fetchHotelImages = async (hotelId) => {
    setLoadingImages(true);
    try {
      const response = await hotelImageApi.get(`/hotel/${hotelId}`);
      if (response.data.status === 200) {
        setHotelImages(response.data.data || []);
      } else {
        toast({
          title: 'Error',
          description: response.data.message || 'Gagal mengambil data gambar',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error('Error fetching hotel images:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat mengambil data gambar',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoadingImages(false);
    }
  };

  const handleImageUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0 || !managingImagesHotel) return;

    // Validate all files
    const invalidFiles = [];
    files.forEach((file, index) => {
      if (!file.type.startsWith('image/')) {
        invalidFiles.push({ name: file.name, reason: 'File harus berupa gambar' });
      } else if (file.size > 5 * 1024 * 1024) {
        invalidFiles.push({ name: file.name, reason: 'Ukuran file maksimal 5MB' });
      }
    });

    if (invalidFiles.length > 0) {
      toast({
        title: 'Error Validasi',
        description: `${invalidFiles.length} file tidak valid: ${invalidFiles.map(f => f.name).join(', ')}`,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      e.target.value = '';
      return;
    }

    // Filter valid files
    const validFiles = files.filter(file => 
      file.type.startsWith('image/') && file.size <= 5 * 1024 * 1024
    );

    if (validFiles.length === 0) {
      e.target.value = '';
      return;
    }

    setUploadingImage(true);
    setUploadProgress({});

    try {
      // Create FormData for multiple file upload
      const formData = new FormData();
      validFiles.forEach(file => {
        formData.append('files', file);
      });
      formData.append('HOTEL_ID', managingImagesHotel.HOTEL_ID);
      formData.append('HOTEL_NAME', managingImagesHotel.HOTEL_NAME || '');
      
      // Upload files to backend
      const response = await hotelImageApi.post('/multiple', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      if (response.data.status === 201) {
        const uploadedCount = response.data.data?.length || 0;
        const failedCount = response.data.failedFiles?.length || 0;
        
        if (failedCount > 0) {
          toast({
            title: 'Berhasil dengan Peringatan',
            description: `Berhasil mengupload ${uploadedCount} gambar. ${failedCount} gambar gagal.`,
            status: 'warning',
            duration: 5000,
            isClosable: true,
          });
        } else {
          toast({
            title: 'Berhasil',
            description: `Berhasil mengupload ${uploadedCount} gambar`,
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
        }
        
        // Refresh images list
        await fetchHotelImages(managingImagesHotel.HOTEL_ID);
        
        // Reset file input
        e.target.value = '';
        setUploadProgress({});
      }
    } catch (error) {
      console.error('Error uploading images:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat mengupload gambar',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setUploadingImage(false);
      setUploadProgress({});
    }
  };

  const handleDeleteImageClick = (image) => {
    setDeleteImage(image);
    onDeleteImageOpen();
  };

  const handleDeleteImageConfirm = async () => {
    if (!deleteImage || !managingImagesHotel) return;

    try {
      const response = await hotelImageApi.post(`/delete/${deleteImage.IMAGEHOTEL_ID}`);
      if (response.data.status === 200) {
        toast({
          title: 'Berhasil',
          description: 'Gambar berhasil dihapus',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        onDeleteImageClose();
        setDeleteImage(null);
        await fetchHotelImages(managingImagesHotel.HOTEL_ID);
      }
    } catch (error) {
      console.error('Error deleting image:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat menghapus gambar',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // ========== LOUNGE FUNCTIONS ==========
  
  const fetchLounges = useCallback(async () => {
    setLoadingLounges(true);
    try {
      const response = await loungeApi.get('/list', {
        params: { 
          includeInactive: true // Show all statuses including non-active for admin
        }
      });
      if (response.data.status === 200) {
        const loungesData = response.data.data || [];
        setLounges(loungesData);
      } else {
        toast({
          title: 'Error',
          description: response.data.message || 'Gagal mengambil data lounge',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error('Error fetching lounges:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat mengambil data',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoadingLounges(false);
    }
  }, [toast]);

  const fetchAirports = useCallback(async () => {
    setLoadingAirports(true);
    try {
      const response = await airportApi.get('/list');
      if (response.data.status === 200) {
        const airportsData = response.data.data || [];
        setAirports(airportsData);
      } else {
        console.error('Error fetching airports:', response.data.message);
      }
    } catch (error) {
      console.error('Error fetching airports:', error);
    } finally {
      setLoadingAirports(false);
    }
  }, []);

  // Filter airports based on search term
  const filteredAirports = useMemo(() => {
    if (!airportSearchTerm) return airports;
    const searchLower = airportSearchTerm.toLowerCase();
    return airports.filter((airport) => {
      return (
        (airport.AIRPORT_CODE && airport.AIRPORT_CODE.toLowerCase().includes(searchLower)) ||
        (airport.AIRPORT_NAME && airport.AIRPORT_NAME.toLowerCase().includes(searchLower)) ||
        (airport.AIRPORT_CITY && airport.AIRPORT_CITY.toLowerCase().includes(searchLower))
      );
    });
  }, [airports, airportSearchTerm]);

  // Get selected airport name for display (for Lounge)
  const selectedAirport = useMemo(() => {
    if (!loungeFormData.AIRPORT_CODE) return null;
    return airports.find(airport => airport.AIRPORT_CODE === loungeFormData.AIRPORT_CODE);
  }, [airports, loungeFormData.AIRPORT_CODE]);

  // Get selected airport name for display (for Baggage)
  const selectedBaggageAirport = useMemo(() => {
    if (!baggageFormData.BAGGAGE_LOCATION) return null;
    return airports.find(airport => airport.AIRPORT_CODE === baggageFormData.BAGGAGE_LOCATION);
  }, [airports, baggageFormData.BAGGAGE_LOCATION]);

  const handleAirportSelect = (airportCode) => {
    setLoungeFormData((prev) => ({
      ...prev,
      AIRPORT_CODE: airportCode,
    }));
    setAirportSearchTerm('');
    setIsAirportDropdownOpen(false);
  };

  useEffect(() => {
    // Fetch lounges dan airports jika di tab List Product (hanya untuk IEEM route)
    if (hasRoleIeem && isIeemRoute && activeIeemTab === 1) {
      fetchLounges();
      fetchAirports();
    }
  }, [fetchLounges, fetchAirports, hasRoleIeem, isIeemRoute, activeIeemTab]);

  const handleLoungeInputChange = (e) => {
    const { name, value } = e.target;
    setLoungeFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLoungeCreate = () => {
    setEditingLounge(null);
    setLoungeFormData({
      LOUNGE_NAME: '',
      LOUNGE_CITY: '',
      LOUNGE_TERMINAL: '',
      AIRPORT_CODE: '',
      LOUNGE_PUBLISRATE: '0',
      LOUNGE_PRICE: '',
      LOUNGE_DISCOUNTPRICE: '',
      LOUNGE_PHONE: '',
      LOUNGE_CONTACTPERSON: '',
      LOUNGE_EMAIL: '',
      LOUNGE_TERMCONDITION: '',
      LOUNGE_MSG: '',
      LOUNGE_STATUS: '1',
      LOUNGE_DESCRIPTION: '',
    });
    setAirportSearchTerm('');
    setIsAirportDropdownOpen(false);
    onLoungeFormOpen();
  };

  const handleLoungeEdit = (lounge) => {
    setEditingLounge(lounge);
    setLoungeFormData({
      LOUNGE_NAME: lounge.LOUNGE_NAME || '',
      LOUNGE_CITY: lounge.LOUNGE_CITY || '',
      LOUNGE_TERMINAL: lounge.LOUNGE_TERMINAL || '',
      AIRPORT_CODE: lounge.AIRPORT_CODE || '',
      LOUNGE_PUBLISRATE: lounge.LOUNGE_PUBLISRATE !== undefined && lounge.LOUNGE_PUBLISRATE !== null ? String(lounge.LOUNGE_PUBLISRATE) : '0',
      LOUNGE_PRICE: lounge.LOUNGE_PRICE || '',
      LOUNGE_DISCOUNTPRICE: lounge.LOUNGE_DISCOUNTPRICE || '',
      LOUNGE_PHONE: lounge.LOUNGE_PHONE || '',
      LOUNGE_CONTACTPERSON: lounge.LOUNGE_CONTACTPERSON || '',
      LOUNGE_EMAIL: lounge.LOUNGE_EMAIL || '',
      LOUNGE_TERMCONDITION: lounge.LOUNGE_TERMCONDITION || '',
      LOUNGE_MSG: lounge.LOUNGE_MSG || '',
      LOUNGE_STATUS: lounge.LOUNGE_STATUS || '1',
      LOUNGE_DESCRIPTION: lounge.LOUNGE_DESCRIPTION || '',
    });
    setAirportSearchTerm('');
    setIsAirportDropdownOpen(false);
    onLoungeFormOpen();
  };

  const handleLoungeSubmit = async () => {
    try {
      const finalSubmitData = {
        ...loungeFormData,
        CREATED_BY: user?.username || user?.nip || 'admin',
      };

      if (editingLounge) {
        const response = await loungeApi.post(`/update/${editingLounge.LOUNGE_ID}`, finalSubmitData);
        if (response.data.status === 200) {
          toast({
            title: 'Berhasil',
            description: 'Lounge berhasil diupdate',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
          onLoungeFormClose();
          fetchLounges();
        }
      } else {
        const response = await loungeApi.post('/', finalSubmitData);
        if (response.data.status === 201) {
          toast({
            title: 'Berhasil',
            description: 'Lounge berhasil ditambahkan',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
          onLoungeFormClose();
          fetchLounges();
        }
      }
    } catch (error) {
      console.error('Error submitting lounge:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat menyimpan data',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleLoungeDeleteClick = (lounge) => {
    setDeleteLounge(lounge);
    onLoungeDeleteOpen();
  };

  const handleLoungeDeleteConfirm = async () => {
    if (!deleteLounge) return;

    try {
      const response = await loungeApi.post(`/delete/${deleteLounge.LOUNGE_ID}`, {
        DELETED_BY: user?.username || user?.nip || 'admin',
      });
      if (response.data.status === 200) {
        toast({
          title: 'Berhasil',
          description: 'Lounge berhasil dihapus',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        onLoungeDeleteClose();
        setDeleteLounge(null);
        fetchLounges();
      }
    } catch (error) {
      console.error('Error deleting lounge:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat menghapus data',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleLoungeView = (lounge) => {
    setViewingLounge(lounge);
    onLoungeViewOpen();
  };

  const handleManageLoungeImages = async (lounge) => {
    setManagingImagesLounge(lounge);
    onLoungeImagesOpen();
    await fetchLoungeImages(lounge.LOUNGE_ID);
  };

  const fetchLoungeImages = async (loungeId) => {
    setLoadingLoungeImages(true);
    try {
      const response = await loungeImageApi.get(`/lounge/${loungeId}`);
      if (response.data.status === 200) {
        setLoungeImages(response.data.data || []);
      }
    } catch (error) {
      console.error('Error fetching lounge images:', error);
      setLoungeImages([]);
    } finally {
      setLoadingLoungeImages(false);
    }
  };

  const handleLoungeImageUpload = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    if (!managingImagesLounge) return;

    setUploadingLoungeImage(true);
    try {
      const formData = new FormData();
      formData.append('LOUNGE_ID', managingImagesLounge.LOUNGE_ID);
      formData.append('LOUNGE_NAME', managingImagesLounge.LOUNGE_NAME || '');

      for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i]);
      }

      const response = await loungeImageApi.post('/multiple', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.status === 201) {
        toast({
          title: 'Berhasil',
          description: `Berhasil mengupload ${response.data.data?.length || files.length} gambar`,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });

        await fetchLoungeImages(managingImagesLounge.LOUNGE_ID);
        e.target.value = '';
      }
    } catch (error) {
      console.error('Error uploading lounge images:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat mengupload gambar',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setUploadingLoungeImage(false);
    }
  };

  const handleDeleteLoungeImageClick = (image) => {
    setDeleteLoungeImage(image);
    onDeleteLoungeImageOpen();
  };

  const handleDeleteLoungeImageConfirm = async () => {
    if (!deleteLoungeImage || !managingImagesLounge) return;

    try {
      const response = await loungeImageApi.post(`/delete/${deleteLoungeImage.IMAGELOUNGE_ID}`, {
        DELETED_BY: user?.username || user?.nip || 'admin',
      });
      if (response.data.status === 200) {
        toast({
          title: 'Berhasil',
          description: 'Gambar berhasil dihapus',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        onDeleteLoungeImageClose();
        setDeleteLoungeImage(null);
        await fetchLoungeImages(managingImagesLounge.LOUNGE_ID);
      }
    } catch (error) {
      console.error('Error deleting lounge image:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat menghapus gambar',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Filter lounges based on search term
  const filteredLounges = useMemo(() => {
    if (!searchTermLounge) return lounges;
    const searchLower = searchTermLounge.toLowerCase();
    return lounges.filter((lounge) => {
      return (
        (lounge.LOUNGE_NAME && lounge.LOUNGE_NAME.toLowerCase().includes(searchLower)) ||
        (lounge.LOUNGE_CITY && lounge.LOUNGE_CITY.toLowerCase().includes(searchLower)) ||
        (lounge.AIRPORT_CODE && lounge.AIRPORT_CODE.toLowerCase().includes(searchLower)) ||
        (lounge.LOUNGE_ID && lounge.LOUNGE_ID.toString().includes(searchLower))
      );
    });
  }, [lounges, searchTermLounge]);

  // ========== CONCIERGE FUNCTIONS ==========
  
  const fetchConcierges = useCallback(async () => {
    setLoadingConcierges(true);
    try {
      const response = await conciergeApi.get('/list', {
        params: { 
          includeInactive: true // Show all statuses including non-active for admin
        }
      });
      if (response.data.status === 200) {
        const conciergesData = response.data.data || [];
        setConcierges(conciergesData);
      } else {
        toast({
          title: 'Error',
          description: response.data.message || 'Gagal mengambil data concierge',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error('Error fetching concierges:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat mengambil data',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoadingConcierges(false);
    }
  }, [toast]);

  useEffect(() => {
    // Fetch concierges jika di tab List Product (hanya untuk IEEM route)
    if (hasRoleIeem && isIeemRoute && activeIeemTab === 1) {
      fetchConcierges();
    }
  }, [fetchConcierges, hasRoleIeem, isIeemRoute, activeIeemTab]);

  const handleConciergeInputChange = (e) => {
    const { name, value } = e.target;
    setConciergeFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleConciergeCreate = () => {
    setEditingConcierge(null);
    setConciergeFormData({
      CONCIERGE_NAME: '',
      CONCIERGE_TYPE: '',
      CONCIERGE_LOCATION: '',
      CONCIERGE_SERVICES: '',
      CONCIERGE_DESCRIPTION: '',
      CONCIERGE_PUBLISHRATE: '0',
      CONCIERGE_PRICE: '',
      CONCIERGE_PHONE: '',
      CONCIERGE_CONTACTPERSON: '',
      CONCIERGE_EMAIL: '',
      CONCIERGE_TERMCONDITION: '',
      CONCIERGE_MSG: '',
      CONCIERGE_STATUS: '1',
    });
    onConciergeFormOpen();
  };

  const handleConciergeEdit = (concierge) => {
    setEditingConcierge(concierge);
    setConciergeFormData({
      CONCIERGE_NAME: concierge.CONCIERGE_NAME || '',
      CONCIERGE_TYPE: concierge.CONCIERGE_TYPE || '',
      CONCIERGE_LOCATION: concierge.CONCIERGE_LOCATION || '',
      CONCIERGE_SERVICES: concierge.CONCIERGE_SERVICES || '',
      CONCIERGE_DESCRIPTION: concierge.CONCIERGE_DESCRIPTION || '',
      CONCIERGE_PUBLISHRATE: concierge.CONCIERGE_PUBLISHRATE !== undefined && concierge.CONCIERGE_PUBLISHRATE !== null ? String(concierge.CONCIERGE_PUBLISHRATE) : '0',
      CONCIERGE_PRICE: concierge.CONCIERGE_PRICE || '',
      CONCIERGE_DISCOUNTPRICE: concierge.CONCIERGE_DISCOUNTPRICE || '',
      CONCIERGE_PHONE: concierge.CONCIERGE_PHONE || '',
      CONCIERGE_CONTACTPERSON: concierge.CONCIERGE_CONTACTPERSON || '',
      CONCIERGE_EMAIL: concierge.CONCIERGE_EMAIL || '',
      CONCIERGE_TERMCONDITION: concierge.CONCIERGE_TERMCONDITION || '',
      CONCIERGE_MSG: concierge.CONCIERGE_MSG || '',
      CONCIERGE_STATUS: concierge.CONCIERGE_STATUS || '1',
      AIRPORT_CODE: concierge.AIRPORT_CODE || '',
      ROUTES_TYPE: concierge.ROUTES_TYPE || '',
      FLIGHT_TYPE: concierge.FLIGHT_TYPE || '',
      ROUTES_TYPETO: concierge.ROUTES_TYPETO || '',
    });
    onConciergeFormOpen();
  };

  const handleConciergeSubmit = async () => {
    try {
      const finalSubmitData = {
        ...conciergeFormData,
        CREATED_BY: user?.username || user?.nip || 'admin',
        UPDATED_BY: user?.username || user?.nip || 'admin',
      };

      if (editingConcierge) {
        const response = await conciergeApi.post(`/update/${editingConcierge.CONCIERGE_ID}`, finalSubmitData);
        if (response.data.status === 200) {
          toast({
            title: 'Berhasil',
            description: 'Concierge berhasil diupdate',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
          onConciergeFormClose();
          fetchConcierges();
        }
      } else {
        const response = await conciergeApi.post('/', finalSubmitData);
        if (response.data.status === 201) {
          toast({
            title: 'Berhasil',
            description: 'Concierge berhasil ditambahkan',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
          onConciergeFormClose();
          fetchConcierges();
        }
      }
    } catch (error) {
      console.error('Error submitting concierge:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat menyimpan data',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleConciergeDeleteClick = (concierge) => {
    setDeleteConcierge(concierge);
    onConciergeDeleteOpen();
  };

  const handleConciergeDeleteConfirm = async () => {
    if (!deleteConcierge) return;

    try {
      const response = await conciergeApi.post(`/delete/${deleteConcierge.CONCIERGE_ID}`, {
        DELETED_BY: user?.username || user?.nip || 'admin',
      });
      if (response.data.status === 200) {
        toast({
          title: 'Berhasil',
          description: 'Concierge berhasil dihapus',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        onConciergeDeleteClose();
        setDeleteConcierge(null);
        fetchConcierges();
      }
    } catch (error) {
      console.error('Error deleting concierge:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat menghapus data',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleConciergeView = (concierge) => {
    setViewingConcierge(concierge);
    onConciergeViewOpen();
  };

  const handleManageConciergeImages = async (concierge) => {
    setManagingImagesConcierge(concierge);
    onConciergeImagesOpen();
    await fetchConciergeImages(concierge.CONCIERGE_ID);
  };

  const fetchConciergeImages = async (conciergeId) => {
    setLoadingConciergeImages(true);
    try {
      const response = await conciergeImageApi.get(`/concierge/${conciergeId}`);
      if (response.data.status === 200) {
        setConciergeImages(response.data.data || []);
      }
    } catch (error) {
      console.error('Error fetching concierge images:', error);
      setConciergeImages([]);
    } finally {
      setLoadingConciergeImages(false);
    }
  };

  const handleConciergeImageUpload = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    if (!managingImagesConcierge) return;

    setUploadingConciergeImage(true);
    try {
      const formData = new FormData();
      formData.append('CONCIERGE_ID', managingImagesConcierge.CONCIERGE_ID);
      formData.append('CONCIERGE_NAME', managingImagesConcierge.CONCIERGE_NAME || '');

      for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i]);
      }

      const response = await conciergeImageApi.post('/multiple', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.status === 201) {
        toast({
          title: 'Berhasil',
          description: `Berhasil mengupload ${response.data.data?.length || files.length} gambar`,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });

        await fetchConciergeImages(managingImagesConcierge.CONCIERGE_ID);
        e.target.value = '';
      }
    } catch (error) {
      console.error('Error uploading concierge images:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat mengupload gambar',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setUploadingConciergeImage(false);
    }
  };

  const handleDeleteConciergeImageClick = (image) => {
    setDeleteConciergeImage(image);
    onDeleteConciergeImageOpen();
  };

  const handleDeleteConciergeImageConfirm = async () => {
    if (!deleteConciergeImage || !managingImagesConcierge) return;

    try {
      const response = await conciergeImageApi.post(`/delete/${deleteConciergeImage.IMAGECONCIERGE_ID}`, {
        DELETED_BY: user?.username || user?.nip || 'admin',
      });
      if (response.data.status === 200) {
        toast({
          title: 'Berhasil',
          description: 'Gambar berhasil dihapus',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        onDeleteConciergeImageClose();
        setDeleteConciergeImage(null);
        await fetchConciergeImages(managingImagesConcierge.CONCIERGE_ID);
      }
    } catch (error) {
      console.error('Error deleting concierge image:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat menghapus gambar',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Filter concierges based on search term
  const filteredConcierges = useMemo(() => {
    if (!searchTermConcierge) return concierges;
    const searchLower = searchTermConcierge.toLowerCase();
    return concierges.filter((concierge) => {
      return (
        (concierge.CONCIERGE_NAME && concierge.CONCIERGE_NAME.toLowerCase().includes(searchLower)) ||
        (concierge.CONCIERGE_LOCATION && concierge.CONCIERGE_LOCATION.toLowerCase().includes(searchLower)) ||
        (concierge.CONCIERGE_TYPE && concierge.CONCIERGE_TYPE.toLowerCase().includes(searchLower)) ||
        (concierge.CONCIERGE_ID && concierge.CONCIERGE_ID.toString().includes(searchLower))
      );
    });
  }, [concierges, searchTermConcierge]);

  // ========== BAGGAGE FUNCTIONS ==========
  
  const fetchBaggages = useCallback(async () => {
    setLoadingBaggages(true);
    try {
      const response = await baggageApi.get('/list', {
        params: { 
          includeInactive: true // Show all statuses including non-active for admin
        }
      });
      if (response.data.status === 200) {
        const baggagesData = response.data.data || [];
        setBaggages(baggagesData);
      } else {
        toast({
          title: 'Error',
          description: response.data.message || 'Gagal mengambil data baggage',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error('Error fetching baggages:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat mengambil data',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoadingBaggages(false);
    }
  }, [toast]);

  useEffect(() => {
    // Fetch baggages jika di tab List Product (hanya untuk IEEM route)
    if (hasRoleIeem && isIeemRoute && activeIeemTab === 1) {
      fetchBaggages();
    }
  }, [fetchBaggages, hasRoleIeem, isIeemRoute, activeIeemTab]);

  const handleBaggageInputChange = (e) => {
    const { name, value } = e.target;
    setBaggageFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleBaggageCreate = () => {
    setEditingBaggage(null);
    setBaggageFormData({
      BAGGAGE_NAME: '',
      BAGGAGE_LOCATION: '',
      BAGGAGE_AREA: '',
      BAGGAGE_DESCRIPTION: '',
      BAGGAGE_PUBLISHRATE: '0',
      BAGGAGE_PRICE: '',
      BAGGAGE_DISCOUNTPRICE: '',
      BAGGAGE_PHONE: '',
      BAGGAGE_CONTACTPERSON: '',
      BAGGAGE_EMAIL: '',
      BAGGAGE_TERMCONDITION: '',
      BAGGAGE_MSG: '',
      BAGGAGE_STATUS: '1',
    });
    setAirportSearchTerm('');
    setIsAirportDropdownOpen(false);
    onBaggageFormOpen();
  };

  const handleBaggageEdit = (baggage) => {
    setEditingBaggage(baggage);
    setBaggageFormData({
      BAGGAGE_NAME: baggage.BAGGAGE_NAME || '',
      BAGGAGE_LOCATION: baggage.BAGGAGE_LOCATION || '',
      BAGGAGE_AREA: baggage.BAGGAGE_AREA || '',
      BAGGAGE_DESCRIPTION: baggage.BAGGAGE_DESCRIPTION || '',
      BAGGAGE_PUBLISHRATE: baggage.BAGGAGE_PUBLISHRATE !== undefined && baggage.BAGGAGE_PUBLISHRATE !== null ? String(baggage.BAGGAGE_PUBLISHRATE) : '0',
      BAGGAGE_PRICE: baggage.BAGGAGE_PRICE || '',
      BAGGAGE_DISCOUNTPRICE: baggage.BAGGAGE_DISCOUNTPRICE || '',
      BAGGAGE_PHONE: baggage.BAGGAGE_PHONE || '',
      BAGGAGE_CONTACTPERSON: baggage.BAGGAGE_CONTACTPERSON || '',
      BAGGAGE_EMAIL: baggage.BAGGAGE_EMAIL || '',
      BAGGAGE_TERMCONDITION: baggage.BAGGAGE_TERMCONDITION || '',
      BAGGAGE_MSG: baggage.BAGGAGE_MSG || '',
      BAGGAGE_STATUS: baggage.BAGGAGE_STATUS || '1',
    });
    setAirportSearchTerm('');
    setIsAirportDropdownOpen(false);
    onBaggageFormOpen();
  };

  const handleBaggageSubmit = async () => {
    try {
      const finalSubmitData = {
        ...baggageFormData,
        CREATED_BY: user?.username || user?.nip || 'admin',
        UPDATED_BY: user?.username || user?.nip || 'admin',
      };

      if (editingBaggage) {
        const response = await baggageApi.post(`/update/${editingBaggage.BAGGAGE_ID}`, finalSubmitData);
        if (response.data.status === 200) {
          toast({
            title: 'Berhasil',
            description: 'Baggage berhasil diupdate',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
          onBaggageFormClose();
          fetchBaggages();
        }
      } else {
        const response = await baggageApi.post('/', finalSubmitData);
        if (response.data.status === 201) {
          toast({
            title: 'Berhasil',
            description: 'Baggage berhasil ditambahkan',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
          onBaggageFormClose();
          fetchBaggages();
        }
      }
    } catch (error) {
      console.error('Error submitting baggage:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat menyimpan data',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleBaggageDeleteClick = (baggage) => {
    setDeleteBaggage(baggage);
    onBaggageDeleteOpen();
  };

  const handleBaggageDeleteConfirm = async () => {
    if (!deleteBaggage) return;

    try {
      const response = await baggageApi.post(`/delete/${deleteBaggage.BAGGAGE_ID}`, {
        DELETED_BY: user?.username || user?.nip || 'admin',
      });
      if (response.data.status === 200) {
        toast({
          title: 'Berhasil',
          description: 'Baggage berhasil dihapus',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        onBaggageDeleteClose();
        setDeleteBaggage(null);
        fetchBaggages();
      }
    } catch (error) {
      console.error('Error deleting baggage:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat menghapus data',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleBaggageView = (baggage) => {
    setViewingBaggage(baggage);
    onBaggageViewOpen();
  };

  const handleManageBaggageImages = async (baggage) => {
    setManagingImagesBaggage(baggage);
    onBaggageImagesOpen();
    await fetchBaggageImages(baggage.BAGGAGE_ID);
  };

  const fetchBaggageImages = async (baggageId) => {
    setLoadingBaggageImages(true);
    try {
      const response = await baggageImageApi.get(`/baggage/${baggageId}`);
      if (response.data.status === 200) {
        setBaggageImages(response.data.data || []);
      }
    } catch (error) {
      console.error('Error fetching baggage images:', error);
      setBaggageImages([]);
    } finally {
      setLoadingBaggageImages(false);
    }
  };

  const handleBaggageImageUpload = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    if (!managingImagesBaggage) return;

    setUploadingBaggageImage(true);
    try {
      const formData = new FormData();
      formData.append('BAGGAGE_ID', managingImagesBaggage.BAGGAGE_ID);
      formData.append('BAGGAGE_NAME', managingImagesBaggage.BAGGAGE_NAME || '');

      for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i]);
      }

      const response = await baggageImageApi.post('/multiple', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.status === 201) {
        toast({
          title: 'Berhasil',
          description: `Berhasil mengupload ${response.data.data?.length || files.length} gambar`,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });

        await fetchBaggageImages(managingImagesBaggage.BAGGAGE_ID);
        e.target.value = '';
      }
    } catch (error) {
      console.error('Error uploading baggage images:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat mengupload gambar',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setUploadingBaggageImage(false);
    }
  };

  const handleDeleteBaggageImageClick = (image) => {
    setDeleteBaggageImage(image);
    onDeleteBaggageImageOpen();
  };

  const handleDeleteBaggageImageConfirm = async () => {
    if (!deleteBaggageImage || !managingImagesBaggage) return;

    try {
      const response = await baggageImageApi.post(`/delete/${deleteBaggageImage.IMAGEBAGGAGE_ID}`, {
        DELETED_BY: user?.username || user?.nip || 'admin',
      });
      if (response.data.status === 200) {
        toast({
          title: 'Berhasil',
          description: 'Gambar berhasil dihapus',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        onDeleteBaggageImageClose();
        setDeleteBaggageImage(null);
        await fetchBaggageImages(managingImagesBaggage.BAGGAGE_ID);
      }
    } catch (error) {
      console.error('Error deleting baggage image:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Terjadi kesalahan saat menghapus gambar',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Filter baggages based on search term
  const filteredBaggages = useMemo(() => {
    if (!searchTermBaggage) return baggages;
    const searchLower = searchTermBaggage.toLowerCase();
    return baggages.filter((baggage) => {
      return (
        (baggage.BAGGAGE_NAME && baggage.BAGGAGE_NAME.toLowerCase().includes(searchLower)) ||
        (baggage.BAGGAGE_LOCATION && baggage.BAGGAGE_LOCATION.toLowerCase().includes(searchLower)) ||
        (baggage.BAGGAGE_AREA && baggage.BAGGAGE_AREA.toLowerCase().includes(searchLower)) ||
        (baggage.BAGGAGE_ID && baggage.BAGGAGE_ID.toString().includes(searchLower))
      );
    });
  }, [baggages, searchTermBaggage]);

  const isMobileView = useBreakpointValue({ base: true, md: false });

  // DataTable columns definition
  const columns = useMemo(
    () => [
      {
        name: 'ID',
        selector: (row) => row.HOTEL_ID,
        sortable: true,
        width: '80px',
        omit: isMobileView,
      },
      {
        name: 'Nama Hotel',
        selector: (row) => row.HOTEL_NAME || '-',
        sortable: true,
        cell: (row) => (
          <VStack align="start" spacing={1}>
            <Text fontWeight="600" fontSize={{ base: 'sm', lg: 'md' }}>
              {row.HOTEL_NAME || '-'}
            </Text>
            {isMobileView && (
              <Text fontSize="xs" color="gray.500">
                ID: {row.HOTEL_ID} | {row.HOTEL_LOCATION || '-'}
              </Text>
            )}
          </VStack>
        ),
      },
      {
        name: 'Lokasi',
        selector: (row) => row.HOTEL_LOCATION || '-',
        sortable: true,
        omit: isMobileView,
      },
      {
        name: 'Bintang',
        selector: (row) => row.HOTEL_STAR,
        sortable: true,
        cell: (row) => (
          <Badge colorScheme="yellow" fontSize={{ base: 'xs', lg: 'sm' }}>
            {row.HOTEL_STAR} ⭐
          </Badge>
        ),
        omit: isMobileView,
      },
      {
        name: 'Status',
        selector: (row) => row.HOTEL_STATUS,
        sortable: true,
        cell: (row) => (
          <Badge
            colorScheme={row.HOTEL_STATUS === '1' || row.HOTEL_STATUS === 1 ? 'green' : 'red'}
            fontSize={{ base: 'xs', lg: 'sm' }}
          >
            {row.HOTEL_STATUS === '1' || row.HOTEL_STATUS === 1 ? 'Active' : 'Not Active'}
          </Badge>
        ),
      },
      {
        name: 'Aksi',
        cell: (row) => (
          <HStack spacing={1} justify="center">
            <IconButton
              icon={<FiEye />}
              size={{ base: 'xs', lg: 'sm' }}
              colorScheme="green"
              variant="ghost"
              onClick={() => handleView(row)}
              aria-label="View"
            />
            <IconButton
              icon={<FiEdit />}
              size={{ base: 'xs', lg: 'sm' }}
              colorScheme="blue"
              variant="ghost"
              onClick={() => handleEdit(row)}
              aria-label="Edit"
            />
            <IconButton
              icon={<FiImage />}
              size={{ base: 'xs', lg: 'sm' }}
              colorScheme="purple"
              variant="ghost"
              onClick={() => handleManageImages(row)}
              aria-label="Manage Images"
            />
            <IconButton
              icon={<FiHome />}
              size={{ base: 'xs', lg: 'sm' }}
              colorScheme="orange"
              variant="ghost"
              onClick={() => handleCreateRoomType(row)}
              aria-label="Manage Room Types"
              title="Kelola Room Types"
            />
            <IconButton
              icon={<FiTrash2 />}
              size={{ base: 'xs', lg: 'sm' }}
              colorScheme="red"
              variant="ghost"
              onClick={() => handleDeleteClick(row)}
              aria-label="Delete"
            />
          </HStack>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
        width: '160px',
      },
    ],
    [isMobileView]
  );

  // Custom styles for DataTable
  const customStyles = {
    headRow: {
      style: {
        backgroundColor: '#f7fafc',
        borderBottom: '1px solid #e2e8f0',
        fontWeight: '600',
      },
    },
    headCells: {
      style: {
        fontSize: '14px',
        fontWeight: '600',
        textTransform: 'none',
        paddingLeft: '16px',
        paddingRight: '16px',
      },
    },
    cells: {
      style: {
        fontSize: '14px',
        paddingLeft: '16px',
        paddingRight: '16px',
      },
    },
    rows: {
      style: {
        minHeight: '60px',
        '&:not(:last-of-type)': {
          borderBottom: '1px solid #e2e8f0',
        },
      },
    },
  };

  // Pagination component options
  const paginationComponentOptions = {
    rowsPerPageText: 'Baris per halaman:',
    rangeSeparatorText: 'dari',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Semua',
  };

  // Filter hotels based on search term
  const filteredHotels = useMemo(() => {
    if (!searchTerm) return hotels;
    const searchLower = searchTerm.toLowerCase();
    return hotels.filter((hotel) => {
      return (
        (hotel.HOTEL_NAME && hotel.HOTEL_NAME.toLowerCase().includes(searchLower)) ||
        (hotel.HOTEL_LOCATION && hotel.HOTEL_LOCATION.toLowerCase().includes(searchLower)) ||
        (hotel.HOTEL_STAR && hotel.HOTEL_STAR.toString().includes(searchLower)) ||
        (hotel.HOTEL_ID && hotel.HOTEL_ID.toString().includes(searchLower))
      );
    });
  }, [hotels, searchTerm]);

  // Lounge DataTable columns definition
  const loungeColumns = useMemo(
    () => [
      {
        name: 'ID',
        selector: (row) => row.LOUNGE_ID,
        sortable: true,
        width: '80px',
        omit: isMobileView,
      },
      {
        name: 'Nama Lounge',
        selector: (row) => row.LOUNGE_NAME || '-',
        sortable: true,
        cell: (row) => (
          <VStack align="start" spacing={1}>
            <Text fontWeight="600" fontSize={{ base: 'sm', lg: 'md' }}>
              {row.LOUNGE_NAME || '-'}
            </Text>
            {isMobileView && (
              <Text fontSize="xs" color="gray.500">
                ID: {row.LOUNGE_ID} | {row.LOUNGE_CITY || '-'}
              </Text>
            )}
          </VStack>
        ),
      },
      {
        name: 'Kota',
        selector: (row) => row.LOUNGE_CITY || '-',
        sortable: true,
        omit: isMobileView,
      },
      {
        name: 'Terminal',
        selector: (row) => row.LOUNGE_TERMINAL || '-',
        sortable: true,
        omit: isMobileView,
      },
      {
        name: 'Kode Bandara',
        selector: (row) => row.AIRPORT_CODE || '-',
        sortable: true,
        omit: isMobileView,
      },
      {
        name: 'Status',
        selector: (row) => row.LOUNGE_STATUS,
        sortable: true,
        cell: (row) => (
          <Badge
            colorScheme={row.LOUNGE_STATUS === '1' || row.LOUNGE_STATUS === 1 ? 'green' : 'red'}
            fontSize={{ base: 'xs', lg: 'sm' }}
          >
            {row.LOUNGE_STATUS === '1' || row.LOUNGE_STATUS === 1 ? 'Active' : 'Not Active'}
          </Badge>
        ),
      },
      {
        name: 'Aksi',
        cell: (row) => (
          <HStack spacing={1} justify="center">
            <IconButton
              icon={<FiEye />}
              size={{ base: 'xs', lg: 'sm' }}
              colorScheme="green"
              variant="ghost"
              onClick={() => handleLoungeView(row)}
              aria-label="View"
            />
            <IconButton
              icon={<FiEdit />}
              size={{ base: 'xs', lg: 'sm' }}
              colorScheme="blue"
              variant="ghost"
              onClick={() => handleLoungeEdit(row)}
              aria-label="Edit"
            />
            <IconButton
              icon={<FiImage />}
              size={{ base: 'xs', lg: 'sm' }}
              colorScheme="purple"
              variant="ghost"
              onClick={() => handleManageLoungeImages(row)}
              aria-label="Manage Images"
            />
            <IconButton
              icon={<FiTrash2 />}
              size={{ base: 'xs', lg: 'sm' }}
              colorScheme="red"
              variant="ghost"
              onClick={() => handleLoungeDeleteClick(row)}
              aria-label="Delete"
            />
          </HStack>
        ),
        width: '180px',
      },
    ],
    [isMobileView]
  );

  const conciergeColumns = useMemo(
    () => [
      {
        name: 'ID',
        selector: (row) => row.CONCIERGE_ID,
        sortable: true,
        width: '80px',
        omit: isMobileView,
      },
      {
        name: 'Nama Concierge',
        selector: (row) => row.CONCIERGE_NAME || '-',
        sortable: true,
        cell: (row) => (
          <VStack align="start" spacing={1}>
            <Text fontWeight="600" fontSize={{ base: 'sm', lg: 'md' }}>
              {row.CONCIERGE_NAME || '-'}
            </Text>
            {isMobileView && (
              <Text fontSize="xs" color="gray.500">
                ID: {row.CONCIERGE_ID} | {row.CONCIERGE_LOCATION || '-'}
              </Text>
            )}
          </VStack>
        ),
      },
      {
        name: 'Tipe',
        selector: (row) => row.CONCIERGE_TYPE || '-',
        sortable: true,
        omit: isMobileView,
      },
      {
        name: 'Lokasi',
        selector: (row) => row.CONCIERGE_LOCATION || '-',
        sortable: true,
        omit: isMobileView,
      },
      {
        name: 'Layanan',
        selector: (row) => row.CONCIERGE_SERVICES || '-',
        sortable: true,
        omit: isMobileView,
      },
      {
        name: 'Status',
        selector: (row) => row.CONCIERGE_STATUS,
        sortable: true,
        cell: (row) => (
          <Badge
            colorScheme={row.CONCIERGE_STATUS === '1' || row.CONCIERGE_STATUS === 1 ? 'green' : 'red'}
            fontSize={{ base: 'xs', lg: 'sm' }}
          >
            {row.CONCIERGE_STATUS === '1' || row.CONCIERGE_STATUS === 1 ? 'Active' : 'Not Active'}
          </Badge>
        ),
      },
      {
        name: 'Aksi',
        cell: (row) => (
          <HStack spacing={1} justify="center">
            <IconButton
              icon={<FiEye />}
              size={{ base: 'xs', lg: 'sm' }}
              colorScheme="green"
              variant="ghost"
              onClick={() => handleConciergeView(row)}
              aria-label="View"
            />
            <IconButton
              icon={<FiEdit />}
              size={{ base: 'xs', lg: 'sm' }}
              colorScheme="blue"
              variant="ghost"
              onClick={() => handleConciergeEdit(row)}
              aria-label="Edit"
            />
            <IconButton
              icon={<FiImage />}
              size={{ base: 'xs', lg: 'sm' }}
              colorScheme="purple"
              variant="ghost"
              onClick={() => handleManageConciergeImages(row)}
              aria-label="Manage Images"
            />
            <IconButton
              icon={<FiTrash2 />}
              size={{ base: 'xs', lg: 'sm' }}
              colorScheme="red"
              variant="ghost"
              onClick={() => handleConciergeDeleteClick(row)}
              aria-label="Delete"
            />
          </HStack>
        ),
        width: '180px',
      },
    ],
    [isMobileView]
  );

  const baggageColumns = useMemo(
    () => [
      {
        name: 'ID',
        selector: (row) => row.BAGGAGE_ID,
        sortable: true,
        width: '80px',
        omit: isMobileView,
      },
      {
        name: 'Nama Baggage',
        selector: (row) => row.BAGGAGE_NAME || '-',
        sortable: true,
        cell: (row) => (
          <VStack align="start" spacing={1}>
            <Text fontWeight="600" fontSize={{ base: 'sm', lg: 'md' }}>
              {row.BAGGAGE_NAME || '-'}
            </Text>
            {isMobileView && (
              <Text fontSize="xs" color="gray.500">
                ID: {row.BAGGAGE_ID} | {row.BAGGAGE_LOCATION || '-'}
              </Text>
            )}
          </VStack>
        ),
      },
      {
        name: 'Lokasi (Airport Code)',
        selector: (row) => row.BAGGAGE_LOCATION || '-',
        sortable: true,
        omit: isMobileView,
      },
      {
        name: 'Area',
        selector: (row) => row.BAGGAGE_AREA || '-',
        sortable: true,
        omit: isMobileView,
      },
      {
        name: 'Status',
        selector: (row) => row.BAGGAGE_STATUS,
        sortable: true,
        cell: (row) => (
          <Badge
            colorScheme={row.BAGGAGE_STATUS === '1' || row.BAGGAGE_STATUS === 1 ? 'green' : 'red'}
            fontSize={{ base: 'xs', lg: 'sm' }}
          >
            {row.BAGGAGE_STATUS === '1' || row.BAGGAGE_STATUS === 1 ? 'Active' : 'Not Active'}
          </Badge>
        ),
      },
      {
        name: 'Aksi',
        cell: (row) => (
          <HStack spacing={1} justify="center">
            <IconButton
              icon={<FiEye />}
              size={{ base: 'xs', lg: 'sm' }}
              colorScheme="green"
              variant="ghost"
              onClick={() => handleBaggageView(row)}
              aria-label="View"
            />
            <IconButton
              icon={<FiEdit />}
              size={{ base: 'xs', lg: 'sm' }}
              colorScheme="blue"
              variant="ghost"
              onClick={() => handleBaggageEdit(row)}
              aria-label="Edit"
            />
            <IconButton
              icon={<FiImage />}
              size={{ base: 'xs', lg: 'sm' }}
              colorScheme="purple"
              variant="ghost"
              onClick={() => handleManageBaggageImages(row)}
              aria-label="Manage Images"
            />
            <IconButton
              icon={<FiTrash2 />}
              size={{ base: 'xs', lg: 'sm' }}
              colorScheme="red"
              variant="ghost"
              onClick={() => handleBaggageDeleteClick(row)}
              aria-label="Delete"
            />
          </HStack>
        ),
        width: '180px',
      },
    ],
    [isMobileView]
  );

  const eyebrow = isIeemRoute
    ? 'IEEM Workspace'
    : isBundlingProductRoute || isIntegrationDataRoute
      ? 'Product Workspace'
      : 'Domain Workspace';

  return (
    <Box>
      <VStack align="stretch" spacing={4} mb={6}>
        <PageHeader
          eyebrow={eyebrow}
          title="Injourney Aviation Services"
          description="Kelola channel IEEM, bundling product, dan operational data Aviation Services."
        />
        <HStack>
          {!isIntegrationDataRoute ? (
            <>
              <Button
                size="sm"
                colorScheme="blue"
                variant={isBundlingProductRoute ? 'solid' : 'outline'}
                onClick={() => navigate('/admin/aviation-services/bundling-product')}
              >
                List Product PRIME
              </Button>
              <Button
                size="sm"
                colorScheme="blue"
                variant="outline"
                onClick={() => navigate('/admin/aviation-services/integrationData')}
              >
                Import Source IAS API
              </Button>
            </>
          ) : (
            <Button
              size="sm"
              variant="outline"
              onClick={() => navigate('/admin/aviation-services/bundling-product')}
            >
              Kembali ke List Product PRIME
            </Button>
          )}
        </HStack>
        <Text fontSize="sm" color="gray.500">
          Source IAS API digunakan untuk import data awal produk, sedangkan Sync & Reporting dipakai untuk monitoring data transaksi IAS.
        </Text>
      </VStack>

      <Card bg="white" borderRadius="16px" boxShadow="sm">
        <CardBody p={{ base: 2, lg: 4 }}>
          {isIntegrationDataRoute ? (
            <VStack align="stretch" spacing={6}>
              <IasIntegrationData onImportProduct={handleImportProductFromIas} />
              <Box>
                <Heading size="sm" color="gray.700" mb={2}>
                  Sync & Reporting IAS
                </Heading>
                <Text fontSize="sm" color="gray.500" mb={4}>
                  Gunakan area ini untuk sinkronisasi transaksi IAS dan analisis performa.
                </Text>
                <ProductWrappingTab />
              </Box>
            </VStack>
          ) : isIeemRoute && hasRoleIeem ? (
            /* Hanya tampilkan tab jika di route IEEM */
          (
            <Tabs index={activeIeemTab} onChange={setActiveIeemTab} isLazy lazyBehavior="keepMounted">
              <TabList>
                <Tab>How To Publish</Tab>
                <Tab>List Product</Tab>
                <Tab>List Flyer</Tab>
                <Tab>List Iframe</Tab>
                <Tab>Reporting</Tab>
              </TabList>

              <TabPanels>
                {/* Tab How To Publish */}
                <TabPanel>
                  <IeemPublishTab memberCode={getMemberCode()} />
                </TabPanel>

                {/* Tab List Product */}
                <TabPanel>
                  {/* Hotel Section */}
                  <VStack align="stretch" spacing={4} mb={8}>
                    {/* Section Header */}
                    <Box
                      bg="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                      borderRadius="12px"
                      p={4}
                      color="white"
                    >
                      <HStack justify="space-between" align="center" flexWrap="wrap">
                        <VStack align="start" spacing={1}>
                          <Heading size="lg" color="white">
                            Hotel
                          </Heading>
                          <Text fontSize="sm" color="whiteAlpha.800">
                            Kelola data hotel untuk Injourney Aviation Services
                          </Text>
                        </VStack>
                        <HStack spacing={3} flexWrap="wrap" mt={{ base: 3, md: 0 }}>
                          <Button
                            leftIcon={<FiRefreshCw />}
                            onClick={fetchHotels}
                            isLoading={loading}
                            variant="outline"
                            colorScheme="whiteAlpha"
                            size={{ base: 'sm', lg: 'md' }}
                            _hover={{ bg: 'whiteAlpha.200' }}
                          >
                            Refresh
                          </Button>
                          <Button
                            leftIcon={<FiPlus />}
                            onClick={handleCreate}
                            bg="white"
                            color="purple.600"
                            size={{ base: 'sm', lg: 'md' }}
                            _hover={{ bg: 'whiteAlpha.900', transform: 'translateY(-2px)' }}
                            boxShadow="md"
                          >
                            <Text display={{ base: 'none', sm: 'block' }}>Tambah Hotel</Text>
                            <Text display={{ base: 'block', sm: 'none' }}>Tambah</Text>
                          </Button>
                        </HStack>
                      </HStack>
                    </Box>

                    {/* Hotel DataTable */}
                    <Card bg="white" borderRadius="12px" boxShadow="sm" border="1px solid" borderColor="gray.200">
                      <CardBody p={4}>
                        <DataTable
                          columns={columns}
                          data={filteredHotels}
                          progressPending={loading}
                          progressComponent={<Text py={8}>Loading...</Text>}
                          noDataComponent={
                            <Text py={8} color="gray.500" textAlign="center">
                              Tidak ada data hotel
                            </Text>
                          }
                          subHeader
                          subHeaderComponent={
                            <Input
                              placeholder="Cari hotel (nama, lokasi, bintang, ID)..."
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                              mb={4}
                              maxW="400px"
                              bg="white"
                              border="1px solid"
                              borderColor="gray.300"
                              _focus={{ borderColor: 'purple.500', boxShadow: '0 0 0 1px purple.500' }}
                            />
                          }
                          pagination
                          paginationPerPage={10}
                          paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                          paginationComponentOptions={paginationComponentOptions}
                          highlightOnHover
                          pointerOnHover
                          customStyles={customStyles}
                          responsive
                          dense
                          striped
                        />
                      </CardBody>
                    </Card>
                  </VStack>

                  {/* Divider with Icon */}
                  <Box position="relative" my={8}>
                    <Divider borderColor="gray.300" borderWidth="2px" />
                    <Box
                      position="absolute"
                      top="50%"
                      left="50%"
                      transform="translate(-50%, -50%)"
                      bg="white"
                      px={4}
                    >
                      <HStack spacing={2} color="gray.500">
                        <Box
                          w="40px"
                          h="40px"
                          borderRadius="full"
                          bg="linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          boxShadow="md"
                        >
                          <Text fontSize="lg" fontWeight="bold" color="white">
                            &
                          </Text>
                        </Box>
                      </HStack>
                    </Box>
                  </Box>

                  {/* Lounge Section */}
                  <VStack align="stretch" spacing={4} mt={8}>
                    {/* Section Header */}
                    <Box
                      bg="linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
                      borderRadius="12px"
                      p={4}
                      color="white"
                    >
                      <HStack justify="space-between" align="center" flexWrap="wrap">
                        <VStack align="start" spacing={1}>
                          <Heading size="lg" color="white">
                            Lounge
                          </Heading>
                          <Text fontSize="sm" color="whiteAlpha.800">
                            Kelola data lounge untuk Injourney Aviation Services
                          </Text>
                        </VStack>
                        <HStack spacing={3} flexWrap="wrap" mt={{ base: 3, md: 0 }}>
                          <Button
                            leftIcon={<FiRefreshCw />}
                            onClick={fetchLounges}
                            isLoading={loadingLounges}
                            variant="outline"
                            colorScheme="whiteAlpha"
                            size={{ base: 'sm', lg: 'md' }}
                            _hover={{ bg: 'whiteAlpha.200' }}
                          >
                            Refresh
                          </Button>
                          <Button
                            leftIcon={<FiPlus />}
                            onClick={handleLoungeCreate}
                            bg="white"
                            color="pink.600"
                            size={{ base: 'sm', lg: 'md' }}
                            _hover={{ bg: 'whiteAlpha.900', transform: 'translateY(-2px)' }}
                            boxShadow="md"
                          >
                            <Text display={{ base: 'none', sm: 'block' }}>Tambah Lounge</Text>
                            <Text display={{ base: 'block', sm: 'none' }}>Tambah</Text>
                          </Button>
                        </HStack>
                      </HStack>
                    </Box>

                    {/* Lounge DataTable */}
                    <Card bg="white" borderRadius="12px" boxShadow="sm" border="1px solid" borderColor="gray.200">
                      <CardBody p={4}>
                        <DataTable
                          columns={loungeColumns}
                          data={filteredLounges}
                          progressPending={loadingLounges}
                          progressComponent={<Text py={8}>Loading...</Text>}
                          noDataComponent={
                            <Text py={8} color="gray.500" textAlign="center">
                              Tidak ada data lounge
                            </Text>
                          }
                          subHeader
                          subHeaderComponent={
                            <Input
                              placeholder="Cari lounge (nama, kota, kode bandara, ID)..."
                              value={searchTermLounge}
                              onChange={(e) => setSearchTermLounge(e.target.value)}
                              mb={4}
                              maxW="400px"
                              bg="white"
                              border="1px solid"
                              borderColor="gray.300"
                              _focus={{ borderColor: 'pink.500', boxShadow: '0 0 0 1px pink.500' }}
                            />
                          }
                          pagination
                          paginationPerPage={10}
                          paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                          paginationComponentOptions={paginationComponentOptions}
                          highlightOnHover
                          pointerOnHover
                          customStyles={customStyles}
                          responsive
                          dense
                          striped
                        />
                      </CardBody>
                    </Card>
                  </VStack>

                  {/* Divider with Icon */}
                  <Box position="relative" my={8}>
                    <Divider borderColor="gray.300" borderWidth="2px" />
                    <Box
                      position="absolute"
                      top="50%"
                      left="50%"
                      transform="translate(-50%, -50%)"
                      bg="white"
                      px={4}
                    >
                      <HStack spacing={2} color="gray.500">
                        <Box
                          w="40px"
                          h="40px"
                          borderRadius="full"
                          bg="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          boxShadow="md"
                        >
                          <Text fontSize="lg" fontWeight="bold" color="white">
                            &
                          </Text>
                        </Box>
                      </HStack>
                    </Box>
                  </Box>

                  {/* Concierge Section */}
                  <VStack align="stretch" spacing={4} mt={8}>
                      {/* Section Header */}
                      <Box
                        bg="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                        borderRadius="12px"
                        p={4}
                        color="white"
                      >
                        <HStack justify="space-between" align="center" flexWrap="wrap">
                          <VStack align="start" spacing={1}>
                            <Heading size="lg" color="white">
                              Concierge
                            </Heading>
                            <Text fontSize="sm" color="whiteAlpha.800">
                              Kelola data concierge untuk Injourney Aviation Services
                            </Text>
                          </VStack>
                          <HStack spacing={3} flexWrap="wrap" mt={{ base: 3, md: 0 }}>
                            <Button
                              leftIcon={<FiRefreshCw />}
                              onClick={fetchConcierges}
                              isLoading={loadingConcierges}
                              variant="outline"
                              colorScheme="whiteAlpha"
                              size={{ base: 'sm', lg: 'md' }}
                              _hover={{ bg: 'whiteAlpha.200' }}
                            >
                              Refresh
                            </Button>
                            <Button
                              leftIcon={<FiPlus />}
                              onClick={handleConciergeCreate}
                              bg="white"
                              color="purple.600"
                              size={{ base: 'sm', lg: 'md' }}
                              _hover={{ bg: 'whiteAlpha.900', transform: 'translateY(-2px)' }}
                              boxShadow="md"
                            >
                              <Text display={{ base: 'none', sm: 'block' }}>Tambah Concierge</Text>
                              <Text display={{ base: 'block', sm: 'none' }}>Tambah</Text>
                            </Button>
                          </HStack>
                        </HStack>
                      </Box>

                      {/* Concierge DataTable */}
                      <Card bg="white" borderRadius="12px" boxShadow="sm" border="1px solid" borderColor="gray.200">
                        <CardBody p={4}>
                          <DataTable
                            columns={conciergeColumns}
                            data={filteredConcierges}
                            progressPending={loadingConcierges}
                            progressComponent={<Text py={8}>Loading...</Text>}
                            noDataComponent={
                              <Text py={8} color="gray.500" textAlign="center">
                                Tidak ada data concierge
                              </Text>
                            }
                            subHeader
                            subHeaderComponent={
                              <Input
                                placeholder="Cari concierge (nama, lokasi, tipe, ID)..."
                                value={searchTermConcierge}
                                onChange={(e) => setSearchTermConcierge(e.target.value)}
                                mb={4}
                                maxW="400px"
                                bg="white"
                                border="1px solid"
                                borderColor="gray.300"
                                _focus={{ borderColor: 'purple.500', boxShadow: '0 0 0 1px purple.500' }}
                              />
                            }
                            pagination
                            paginationPerPage={10}
                            paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                            paginationComponentOptions={paginationComponentOptions}
                            highlightOnHover
                            pointerOnHover
                            customStyles={customStyles}
                            responsive
                            dense
                            striped
                          />
                        </CardBody>
                      </Card>
                  </VStack>

                  {/* Divider between Concierge and Baggage */}
                  <Box mt={8} mb={4}>
                    <HStack justify="center" align="center">
                      <Box flex={1} height="1px" bg="gray.300" />
                      <Box
                        bg="gray.100"
                        borderRadius="full"
                        p={2}
                        boxShadow="md"
                      >
                        <Text fontSize="lg" fontWeight="bold" color="gray.600">
                          &
                        </Text>
                      </Box>
                      <Box flex={1} height="1px" bg="gray.300" />
                    </HStack>
                  </Box>

                  {/* Baggage Section */}
                  <VStack align="stretch" spacing={4} mt={8}>
                      {/* Section Header */}
                      <Box
                        bg="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                        borderRadius="12px"
                        p={4}
                        color="white"
                      >
                        <HStack justify="space-between" align="center" flexWrap="wrap">
                          <VStack align="start" spacing={1}>
                            <Heading size="lg" color="white">
                              Baggage Service
                            </Heading>
                            <Text fontSize="sm" color="whiteAlpha.800">
                              Kelola data baggage service untuk Injourney Aviation Services
                            </Text>
                          </VStack>
                          <HStack spacing={3} flexWrap="wrap" mt={{ base: 3, md: 0 }}>
                            <Button
                              leftIcon={<FiRefreshCw />}
                              onClick={fetchBaggages}
                              isLoading={loadingBaggages}
                              variant="outline"
                              colorScheme="whiteAlpha"
                              size={{ base: 'sm', lg: 'md' }}
                              _hover={{ bg: 'whiteAlpha.200' }}
                            >
                              Refresh
                            </Button>
                            <Button
                              leftIcon={<FiPlus />}
                              onClick={handleBaggageCreate}
                              bg="white"
                              color="purple.600"
                              size={{ base: 'sm', lg: 'md' }}
                              _hover={{ bg: 'whiteAlpha.900', transform: 'translateY(-2px)' }}
                              boxShadow="md"
                            >
                              <Text display={{ base: 'none', sm: 'block' }}>Tambah Baggage</Text>
                              <Text display={{ base: 'block', sm: 'none' }}>Tambah</Text>
                            </Button>
                          </HStack>
                        </HStack>
                      </Box>

                      {/* Baggage DataTable */}
                      <Card bg="white" borderRadius="12px" boxShadow="sm" border="1px solid" borderColor="gray.200">
                        <CardBody p={4}>
                          <DataTable
                            columns={baggageColumns}
                            data={filteredBaggages}
                            progressPending={loadingBaggages}
                            progressComponent={<Text py={8}>Loading...</Text>}
                            noDataComponent={
                              <Text py={8} color="gray.500" textAlign="center">
                                Tidak ada data baggage
                              </Text>
                            }
                            subHeader
                            subHeaderComponent={
                              <Input
                                placeholder="Cari baggage (nama, lokasi, area, ID)..."
                                value={searchTermBaggage}
                                onChange={(e) => setSearchTermBaggage(e.target.value)}
                                mb={4}
                                maxW="400px"
                                bg="white"
                                border="1px solid"
                                borderColor="gray.300"
                                _focus={{ borderColor: 'purple.500', boxShadow: '0 0 0 1px purple.500' }}
                              />
                            }
                            pagination
                            paginationPerPage={10}
                            paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                            paginationComponentOptions={paginationComponentOptions}
                            highlightOnHover
                            pointerOnHover
                            customStyles={customStyles}
                            responsive
                            dense
                            striped
                          />
                        </CardBody>
                      </Card>
                  </VStack>
                </TabPanel>

                {/* Tab List Flyer */}
                <TabPanel>
                  <IeemFlyerTab memberCode={getMemberCode()} />
                </TabPanel>

                {/* Tab List Iframe */}
                <TabPanel>
                  <IeemIframeTab memberCode={getMemberCode()} />
                </TabPanel>

                {/* Tab Reporting */}
                <TabPanel>
                  <ProductWrappingTab />
                </TabPanel>
              </TabPanels>
            </Tabs>
          )
          ) : isBundlingProductRoute && hasRoleBp ? (
            // Bundling Product route
            <BundlingProductTab
              memberId={getMemberCode()}
              importedProduct={importedProductDraft}
              onImportedProductConsumed={handleImportedProductConsumed}
            />
          ) : (
            // Default - redirect ke IEEM
            <VStack align="stretch" spacing={4}>
              <Text color="gray.600">
                Memuat...
              </Text>
            </VStack>
          )}
        </CardBody>
      </Card>

      {/* Create/Edit Modal */}
      <Modal isOpen={isFormOpen} onClose={onFormClose} size="xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {editingHotel ? 'Edit Hotel' : 'Tambah Hotel Baru'}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4}>
              <FormControl isRequired>
                <FormLabel>Nama Hotel</FormLabel>
                <Input
                  name="HOTEL_NAME"
                  value={formData.HOTEL_NAME}
                  onChange={handleInputChange}
                  placeholder="Masukkan nama hotel"
                />
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Bintang</FormLabel>
                <Select
                  name="HOTEL_STAR"
                  value={formData.HOTEL_STAR}
                  onChange={handleInputChange}
                  placeholder="Pilih bintang"
                >
                  <option value="">Pilih bintang</option>
                  <option value="1">Bintang 1</option>
                  <option value="2">Bintang 2</option>
                  <option value="3">Bintang 3</option>
                  <option value="4">Bintang 4</option>
                  <option value="5">Bintang 5</option>
                </Select>
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Lokasi</FormLabel>
                <Input
                  name="HOTEL_LOCATION"
                  value={formData.HOTEL_LOCATION}
                  onChange={handleInputChange}
                  placeholder="Masukkan lokasi hotel"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Deskripsi</FormLabel>
                <Textarea
                  name="HOTEL_DESCRIPTION"
                  value={formData.HOTEL_DESCRIPTION}
                  onChange={handleInputChange}
                  placeholder="Masukkan deskripsi hotel"
                  rows={4}
                />
              </FormControl>

              {/* Room Option - Hidden, now using Room Types instead */}
              {/* <FormControl>
                <FormLabel>Room Option</FormLabel>
                <CheckboxGroup
                  value={formData.HOTEL_ROOMOPTION || []}
                  onChange={handleRoomOptionChange}
                  colorScheme="brand"
                >
                  <VStack align="start" spacing={2} maxH="300px" overflowY="auto" p={2} border="1px solid" borderColor="gray.200" borderRadius="md">
                    {roomOptions.map((option) => (
                      <Checkbox key={option} value={option}>
                        {option}
                      </Checkbox>
                    ))}
                  </VStack>
                </CheckboxGroup>
              </FormControl> */}

              {/* Price - Hidden, now using Room Types instead */}
              {/* <FormControl>
                <FormLabel>Price</FormLabel>
                <Input
                  name="HOTEL_DISCOUNT"
                  value={formData.HOTEL_DISCOUNT}
                  onChange={handleInputChange}
                  placeholder="Masukkan price"
                  type="number"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Fixed Price</FormLabel>
                <Input
                  name="HOTEL_FIXEDPRICE"
                  value={formData.HOTEL_FIXEDPRICE}
                  onChange={handleInputChange}
                  placeholder="Masukkan fixed price"
                  type="text"
                />
              </FormControl> */}

              <FormControl>
                <FormLabel>Publish Rate</FormLabel>
                <Select
                  name="HOTEL_PUBLISHRATE"
                  value={formData.HOTEL_PUBLISHRATE}
                  onChange={handleInputChange}
                >
                  <option value="0">Not Active</option>
                  <option value="1">Active</option>
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>Contact Person</FormLabel>
                <Input
                  name="HOTEL_CONTACTPERSON"
                  value={formData.HOTEL_CONTACTPERSON}
                  onChange={handleInputChange}
                  placeholder="Masukkan contact person"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Phone</FormLabel>
                <Input
                  name="HOTEL_PHONE"
                  value={formData.HOTEL_PHONE}
                  onChange={handleInputChange}
                  placeholder="Masukkan nomor telepon"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Email</FormLabel>
                <Input
                  name="HOTEL_EMAIL"
                  value={formData.HOTEL_EMAIL}
                  onChange={handleInputChange}
                  placeholder="Masukkan email"
                  type="email"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Term & Condition</FormLabel>
                <Textarea
                  name="HOTEL_TERMCONDITION"
                  value={formData.HOTEL_TERMCONDITION}
                  onChange={handleInputChange}
                  placeholder="Masukkan term & condition"
                  rows={3}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Message</FormLabel>
                <Textarea
                  name="HOTEL_MSG"
                  value={formData.HOTEL_MSG}
                  onChange={handleInputChange}
                  placeholder="Masukkan message"
                  rows={3}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Booking URL</FormLabel>
                <Input
                  name="HOTEL_BOOKINGURL"
                  value={formData.HOTEL_BOOKINGURL}
                  onChange={handleInputChange}
                  placeholder="Masukkan booking URL"
                  type="url"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Status</FormLabel>
                <Select
                  name="HOTEL_STATUS"
                  value={formData.HOTEL_STATUS}
                  onChange={handleInputChange}
                >
                  <option value="1">Active (Show)</option>
                  <option value="0">Not Active (Hide)</option>
                </Select>
              </FormControl>

            </VStack>
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onFormClose}>
              Batal
            </Button>
            <Button colorScheme="brand" onClick={handleSubmit}>
              {editingHotel ? 'Update' : 'Simpan'}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* View Modal */}
      <Modal isOpen={isViewOpen} onClose={onViewClose} size="xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            Detail Hotel
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {viewingHotel && (
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text fontSize="xs" fontWeight="600" color="gray.500" mb={1}>Nama Hotel</Text>
                  <Text fontSize="md" fontWeight="600" color="gray.800">{viewingHotel.HOTEL_NAME || '-'}</Text>
                </Box>

                <HStack spacing={4}>
                  <Box flex={1}>
                    <Text fontSize="xs" fontWeight="600" color="gray.500" mb={1}>Bintang</Text>
                    <Badge colorScheme="yellow">
                      {viewingHotel.HOTEL_STAR} ⭐
                    </Badge>
                  </Box>
                  <Box flex={1}>
                    <Text fontSize="xs" fontWeight="600" color="gray.500" mb={1}>Lokasi</Text>
                    <Text fontSize="md" color="gray.700">{viewingHotel.HOTEL_LOCATION || '-'}</Text>
                  </Box>
                </HStack>

                {viewingHotel.HOTEL_DESCRIPTION && (
                  <Box>
                    <Text fontSize="xs" fontWeight="600" color="gray.500" mb={1}>Deskripsi</Text>
                    <Text fontSize="sm" color="gray.700" whiteSpace="pre-wrap">{viewingHotel.HOTEL_DESCRIPTION}</Text>
                  </Box>
                )}

                {viewingHotel.HOTEL_ROOMOPTION && (
                  <Box>
                    <Text fontSize="xs" fontWeight="600" color="gray.500" mb={1}>Room Option</Text>
                    <HStack spacing={2} flexWrap="wrap">
                      {(() => {
                        const roomOptions = typeof viewingHotel.HOTEL_ROOMOPTION === 'string' 
                          ? viewingHotel.HOTEL_ROOMOPTION.split(/[;,]/).map(r => r.trim()).filter(r => r)
                          : (Array.isArray(viewingHotel.HOTEL_ROOMOPTION) ? viewingHotel.HOTEL_ROOMOPTION : []);
                        return roomOptions.map((option, index) => (
                          <Badge key={index} colorScheme="blue" fontSize="sm">
                            {option}
                          </Badge>
                        ));
                      })()}
                    </HStack>
                  </Box>
                )}

                {/* Price - Hidden, now using Room Types instead */}
                {/* <HStack spacing={4}>
                  {viewingHotel.HOTEL_DISCOUNT && (
                    <Box flex={1}>
                      <Text fontSize="xs" fontWeight="600" color="gray.500" mb={1}>Price</Text>
                      <Text fontSize="md" color="gray.700" fontWeight="600">
                        {new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(Number(viewingHotel.HOTEL_DISCOUNT))}
                      </Text>
                    </Box>
                  )}
                  <Box flex={1}>
                    <Text fontSize="xs" fontWeight="600" color="gray.500" mb={1}>Publish Rate</Text>
                    <Badge colorScheme={viewingHotel.HOTEL_PUBLISHRATE === 1 || viewingHotel.HOTEL_PUBLISHRATE === '1' ? 'green' : 'red'}>
                      {viewingHotel.HOTEL_PUBLISHRATE === 1 || viewingHotel.HOTEL_PUBLISHRATE === '1' ? 'Active' : 'Not Active'}
                    </Badge>
                  </Box>
                </HStack> */}

                <Box>
                  <Text fontSize="xs" fontWeight="600" color="gray.500" mb={1}>Publish Rate</Text>
                  <Badge colorScheme={viewingHotel.HOTEL_PUBLISHRATE === 1 || viewingHotel.HOTEL_PUBLISHRATE === '1' ? 'green' : 'red'}>
                    {viewingHotel.HOTEL_PUBLISHRATE === 1 || viewingHotel.HOTEL_PUBLISHRATE === '1' ? 'Active' : 'Not Active'}
                  </Badge>
                </Box>

                {(viewingHotel.HOTEL_CONTACTPERSON || viewingHotel.HOTEL_PHONE || viewingHotel.HOTEL_EMAIL) && (
                  <Box>
                    <Text fontSize="xs" fontWeight="600" color="gray.500" mb={2}>Kontak</Text>
                    <VStack align="stretch" spacing={2}>
                      {viewingHotel.HOTEL_CONTACTPERSON && (
                        <HStack>
                          <Text fontSize="xs" color="gray.500" minW="120px">Contact Person:</Text>
                          <Text fontSize="sm" color="gray.700">{viewingHotel.HOTEL_CONTACTPERSON}</Text>
                        </HStack>
                      )}
                      {viewingHotel.HOTEL_PHONE && (
                        <HStack>
                          <Text fontSize="xs" color="gray.500" minW="120px">Phone:</Text>
                          <Text fontSize="sm" color="gray.700">{viewingHotel.HOTEL_PHONE}</Text>
                        </HStack>
                      )}
                      {viewingHotel.HOTEL_EMAIL && (
                        <HStack>
                          <Text fontSize="xs" color="gray.500" minW="120px">Email:</Text>
                          <Text fontSize="sm" color="gray.700">{viewingHotel.HOTEL_EMAIL}</Text>
                        </HStack>
                      )}
                    </VStack>
                  </Box>
                )}

                {viewingHotel.HOTEL_BOOKINGURL && (
                  <Box>
                    <Text fontSize="xs" fontWeight="600" color="gray.500" mb={1}>Booking URL</Text>
                    <Text fontSize="sm" color="blue.600" as="a" href={viewingHotel.HOTEL_BOOKINGURL} target="_blank" rel="noopener noreferrer" wordBreak="break-all">
                      {viewingHotel.HOTEL_BOOKINGURL}
                    </Text>
                  </Box>
                )}

                {viewingHotel.HOTEL_TERMCONDITION && (
                  <Box>
                    <Text fontSize="xs" fontWeight="600" color="gray.500" mb={1}>Term & Condition</Text>
                    <Text fontSize="sm" color="gray.700" whiteSpace="pre-wrap">{viewingHotel.HOTEL_TERMCONDITION}</Text>
                  </Box>
                )}

                {viewingHotel.HOTEL_MSG && (
                  <Box>
                    <Text fontSize="xs" fontWeight="600" color="gray.500" mb={1}>Message</Text>
                    <Text fontSize="sm" color="gray.700" whiteSpace="pre-wrap">{viewingHotel.HOTEL_MSG}</Text>
                  </Box>
                )}

                <Divider />

                {/* Room Types Section */}
                <Box>
                  <HStack justify="space-between" mb={3}>
                    <Text fontSize="sm" fontWeight="600" color="gray.700">Room Types</Text>
                    <Button 
                      size="sm" 
                      colorScheme="brand" 
                      leftIcon={<FiPlus />} 
                      onClick={() => {
                        if (viewingHotel) {
                          handleCreateRoomType(viewingHotel);
                        } else {
                          handleCreateRoomType();
                        }
                      }}
                    >
                      Tambah Room Type
                    </Button>
                  </HStack>
                  {loadingRoomTypes ? (
                    <VStack py={4}>
                      <Spinner size="sm" />
                      <Text fontSize="xs" color="gray.500">Memuat room types...</Text>
                    </VStack>
                  ) : roomTypes.length > 0 ? (
                    <VStack align="stretch" spacing={2}>
                      {roomTypes.map((roomType) => (
                        <Box key={roomType.ROOMTYPE_ID} p={3} border="1px solid" borderColor="gray.200" borderRadius="md">
                          <HStack justify="space-between" mb={2}>
                            <Text fontSize="sm" fontWeight="600" color="gray.800">
                              {roomType.ROOMTYPE_NAME}
                              {roomType.ROOMTYPE_CODE && (
                                <Badge ml={2} colorScheme="blue" fontSize="xs">
                                  {roomType.ROOMTYPE_CODE}
                                </Badge>
                              )}
                            </Text>
                            <HStack>
                              <IconButton
                                icon={<FiEdit />}
                                size="xs"
                                colorScheme="blue"
                                variant="ghost"
                                onClick={() => handleEditRoomType(roomType)}
                                aria-label="Edit"
                              />
                              <IconButton
                                icon={<FiTrash2 />}
                                size="xs"
                                colorScheme="red"
                                variant="ghost"
                                onClick={() => handleDeleteRoomTypeClick(roomType)}
                                aria-label="Delete"
                              />
                            </HStack>
                          </HStack>
                          <VStack align="stretch" spacing={1} fontSize="xs" color="gray.600">
                            {(roomType.ROOMTYPE_BASEOCCUPANCY || roomType.ROOMTYPE_MAXOCCUPANCY) && (
                              <HStack>
                                <Text minW="120px">Occupancy:</Text>
                                <Text>
                                  {roomType.ROOMTYPE_BASEOCCUPANCY || '-'} - {roomType.ROOMTYPE_MAXOCCUPANCY || '-'} orang
                                </Text>
                              </HStack>
                            )}
                            {(roomType.ROOMTYPE_DISCOUNTPRICE || roomType.ROOMTYPE_FIXEDPRICE) && (
                              <HStack>
                                <Text minW="120px">Harga:</Text>
                                <HStack spacing={2}>
                                  {roomType.ROOMTYPE_FIXEDPRICE && (
                                    <Text textDecoration={roomType.ROOMTYPE_DISCOUNTPRICE ? 'line-through' : 'none'} color="gray.500">
                                      {formatRupiah(roomType.ROOMTYPE_FIXEDPRICE)}
                                    </Text>
                                  )}
                                  {roomType.ROOMTYPE_DISCOUNTPRICE && (
                                    <Text fontWeight="600" color="blue.600">
                                      {formatRupiah(roomType.ROOMTYPE_DISCOUNTPRICE)}
                                    </Text>
                                  )}
                                </HStack>
                              </HStack>
                            )}
                            {roomType.ROOMTYPE_DESCRIPTION && (
                              <Text fontSize="xs" color="gray.600" whiteSpace="pre-wrap">
                                {roomType.ROOMTYPE_DESCRIPTION}
                              </Text>
                            )}
                          </VStack>
                        </Box>
                      ))}
                    </VStack>
                  ) : (
                    <Text fontSize="sm" color="gray.500" textAlign="center" py={4}>
                      Belum ada room types. Klik "Tambah Room Type" untuk menambahkan.
                    </Text>
                  )}
                </Box>

                <Box>
                  <Text fontSize="xs" fontWeight="600" color="gray.500" mb={1}>Status</Text>
                  <Badge colorScheme={viewingHotel.HOTEL_STATUS === '1' || viewingHotel.HOTEL_STATUS === 1 ? 'green' : 'red'}>
                    {viewingHotel.HOTEL_STATUS === '1' || viewingHotel.HOTEL_STATUS === 1 ? 'Active (Show)' : 'Not Active (Hide)'}
                  </Badge>
                </Box>
              </VStack>
            )}
          </ModalBody>
          <ModalFooter>
            <Button onClick={onViewClose}>Tutup</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Room Types Manage Modal - Single modal for list and form */}
      <Modal 
        isOpen={isRoomTypeFormOpen} 
        onClose={onRoomTypeFormClose} 
        size="xl" 
        scrollBehavior="inside" 
        isCentered
        blockScrollOnMount={true}
        closeOnOverlayClick={true}
        motionPreset="slideInBottom"
      >
        <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(10px)" zIndex={1400} />
        <ModalContent zIndex={1500} maxH="90vh">
          <ModalHeader>
            Kelola Room Types - {editingHotel?.HOTEL_NAME || viewingHotel?.HOTEL_NAME || 'Hotel'}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody 
            overflowY="auto" 
            maxH="calc(90vh - 180px)"
            onWheel={(e) => {
              e.stopPropagation();
            }}
            css={{
              '&::-webkit-scrollbar': {
                width: '8px',
              },
              '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#888',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: '#555',
              },
            }}
          >
            <VStack spacing={6} align="stretch">
              {/* Room Types List Section */}
              <Box>
                <HStack justify="space-between" mb={3}>
                  <Text fontSize="md" fontWeight="600" color="gray.700">Daftar Room Types</Text>
                  <Button size="sm" colorScheme="brand" leftIcon={<FiPlus />} onClick={() => {
                    setEditingRoomType(null);
                    setRoomTypeFormData({
                      ROOMTYPE_CODE: '',
                      ROOMTYPE_NAME: '',
                      ROOMTYPE_BASEOCCUPANCY: '',
                      ROOMTYPE_MAXOCCUPANCY: '',
                      ROOMTYPE_DESCRIPTION: '',
                      ROOMTYPE_DISCOUNTPRICE: '',
                      ROOMTYPE_FIXEDPRICE: '',
                    });
                  }}>
                    Tambah Baru
                  </Button>
                </HStack>
                {loadingRoomTypes ? (
                  <VStack py={4}>
                    <Spinner size="sm" />
                    <Text fontSize="xs" color="gray.500">Memuat room types...</Text>
                  </VStack>
                ) : roomTypes.length > 0 ? (
                  <VStack align="stretch" spacing={2} maxH="250px" overflowY="auto" css={{
                    '&::-webkit-scrollbar': {
                      width: '6px',
                    },
                    '&::-webkit-scrollbar-track': {
                      background: '#f1f1f1',
                      borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      background: '#888',
                      borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      background: '#555',
                    },
                  }}>
                    {roomTypes.map((roomType) => (
                      <Box key={roomType.ROOMTYPE_ID} p={3} border="1px solid" borderColor={editingRoomType?.ROOMTYPE_ID === roomType.ROOMTYPE_ID ? 'brand.500' : 'gray.200'} borderRadius="md" bg={editingRoomType?.ROOMTYPE_ID === roomType.ROOMTYPE_ID ? 'brand.50' : 'white'}>
                        <HStack justify="space-between" mb={2}>
                          <Text fontSize="sm" fontWeight="600" color="gray.800">
                            {roomType.ROOMTYPE_NAME}
                            {roomType.ROOMTYPE_CODE && (
                              <Badge ml={2} colorScheme="blue" fontSize="xs">
                                {roomType.ROOMTYPE_CODE}
                              </Badge>
                            )}
                          </Text>
                          <HStack>
                            <IconButton
                              icon={<FiEdit />}
                              size="xs"
                              colorScheme="blue"
                              variant="ghost"
                              onClick={() => handleEditRoomType(roomType)}
                              aria-label="Edit"
                            />
                            <IconButton
                              icon={<FiTrash2 />}
                              size="xs"
                              colorScheme="red"
                              variant="ghost"
                              onClick={() => handleDeleteRoomTypeClick(roomType)}
                              aria-label="Delete"
                            />
                          </HStack>
                        </HStack>
                        <VStack align="stretch" spacing={1} fontSize="xs" color="gray.600">
                          {(roomType.ROOMTYPE_BASEOCCUPANCY || roomType.ROOMTYPE_MAXOCCUPANCY) && (
                            <HStack>
                              <Text minW="120px">Occupancy:</Text>
                              <Text>
                                {roomType.ROOMTYPE_BASEOCCUPANCY || '-'} - {roomType.ROOMTYPE_MAXOCCUPANCY || '-'} orang
                              </Text>
                            </HStack>
                          )}
                          {(roomType.ROOMTYPE_DISCOUNTPRICE || roomType.ROOMTYPE_FIXEDPRICE) && (
                            <HStack>
                              <Text minW="120px">Harga:</Text>
                              <HStack spacing={2}>
                                {roomType.ROOMTYPE_FIXEDPRICE && (
                                  <Text textDecoration={roomType.ROOMTYPE_DISCOUNTPRICE ? 'line-through' : 'none'} color="gray.500">
                                    {roomType.ROOMTYPE_FIXEDPRICE}
                                  </Text>
                                )}
                                {roomType.ROOMTYPE_DISCOUNTPRICE && (
                                  <Text fontWeight="600" color="blue.600">
                                    {roomType.ROOMTYPE_DISCOUNTPRICE}
                                  </Text>
                                )}
                              </HStack>
                            </HStack>
                          )}
                        </VStack>
                      </Box>
                    ))}
                  </VStack>
                ) : (
                  <Text fontSize="sm" color="gray.500" textAlign="center" py={4}>
                    Belum ada room types. Gunakan form di bawah untuk menambahkan.
                  </Text>
                )}
              </Box>

              <Divider />

              {/* Room Type Form Section */}
              <Box>
                <Text fontSize="md" fontWeight="600" color="gray.700" mb={4}>
                  {editingRoomType ? 'Edit Room Type' : 'Tambah Room Type Baru'}
                </Text>
                <VStack spacing={4}>
                  <FormControl>
                    <FormLabel>Room Type Code</FormLabel>
                    <Input
                      name="ROOMTYPE_CODE"
                      value={roomTypeFormData.ROOMTYPE_CODE}
                      onChange={(e) => setRoomTypeFormData({ ...roomTypeFormData, ROOMTYPE_CODE: e.target.value })}
                      placeholder="Masukkan kode room type (opsional)"
                    />
                  </FormControl>

                  <FormControl isRequired>
                    <FormLabel>Room Type Name</FormLabel>
                    <Input
                      name="ROOMTYPE_NAME"
                      value={roomTypeFormData.ROOMTYPE_NAME}
                      onChange={(e) => setRoomTypeFormData({ ...roomTypeFormData, ROOMTYPE_NAME: e.target.value })}
                      placeholder="Masukkan nama room type"
                    />
                  </FormControl>

                  <HStack spacing={4} w="100%">
                    <FormControl>
                      <FormLabel>Base Occupancy</FormLabel>
                      <Input
                        name="ROOMTYPE_BASEOCCUPANCY"
                        value={roomTypeFormData.ROOMTYPE_BASEOCCUPANCY}
                        onChange={(e) => setRoomTypeFormData({ ...roomTypeFormData, ROOMTYPE_BASEOCCUPANCY: e.target.value })}
                        placeholder="Min"
                        type="number"
                      />
                    </FormControl>

                    <FormControl>
                      <FormLabel>Max Occupancy</FormLabel>
                      <Input
                        name="ROOMTYPE_MAXOCCUPANCY"
                        value={roomTypeFormData.ROOMTYPE_MAXOCCUPANCY}
                        onChange={(e) => setRoomTypeFormData({ ...roomTypeFormData, ROOMTYPE_MAXOCCUPANCY: e.target.value })}
                        placeholder="Max"
                        type="number"
                      />
                    </FormControl>
                  </HStack>

                  <FormControl>
                    <FormLabel>Description</FormLabel>
                    <Textarea
                      name="ROOMTYPE_DESCRIPTION"
                      value={roomTypeFormData.ROOMTYPE_DESCRIPTION}
                      onChange={(e) => setRoomTypeFormData({ ...roomTypeFormData, ROOMTYPE_DESCRIPTION: e.target.value })}
                      placeholder="Masukkan deskripsi room type"
                      rows={3}
                    />
                  </FormControl>

                  <FormControl>
                    <FormLabel>Discount Price</FormLabel>
                    <Input
                      name="ROOMTYPE_DISCOUNTPRICE"
                      value={roomTypeFormData.ROOMTYPE_DISCOUNTPRICE}
                      onChange={(e) => setRoomTypeFormData({ ...roomTypeFormData, ROOMTYPE_DISCOUNTPRICE: e.target.value })}
                      placeholder="Masukkan discount price"
                      type="text"
                    />
                  </FormControl>

                  <FormControl>
                    <FormLabel>Fixed Price</FormLabel>
                    <Input
                      name="ROOMTYPE_FIXEDPRICE"
                      value={roomTypeFormData.ROOMTYPE_FIXEDPRICE}
                      onChange={(e) => setRoomTypeFormData({ ...roomTypeFormData, ROOMTYPE_FIXEDPRICE: e.target.value })}
                      placeholder="Masukkan fixed price"
                      type="text"
                    />
                  </FormControl>
                </VStack>
              </Box>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onRoomTypeFormClose}>
              Tutup
            </Button>
            <Button colorScheme="brand" onClick={handleSubmitRoomType}>
              {editingRoomType ? 'Update' : 'Simpan'}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Delete Room Type Confirmation Dialog */}
      <AlertDialog
        isOpen={isDeleteRoomTypeOpen}
        leastDestructiveRef={cancelRef}
        onClose={onDeleteRoomTypeClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Hapus Room Type
            </AlertDialogHeader>
            <AlertDialogBody>
              Apakah Anda yakin ingin menghapus room type <strong>{deleteRoomType?.ROOMTYPE_NAME}</strong>?
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onDeleteRoomTypeClose}>
                Batal
              </Button>
              <Button colorScheme="red" onClick={handleDeleteRoomTypeConfirm} ml={3}>
                Hapus
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* Delete Confirmation Dialog */}
      <AlertDialog
        isOpen={isDeleteOpen}
        leastDestructiveRef={cancelRef}
        onClose={onDeleteClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Hapus Hotel
            </AlertDialogHeader>

            <AlertDialogBody>
              Apakah Anda yakin ingin menghapus hotel <strong>{deleteHotel?.HOTEL_NAME}</strong>?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onDeleteClose}>
                Batal
              </Button>
              <Button colorScheme="red" onClick={handleDeleteConfirm} ml={3}>
                Hapus
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* Manage Images Modal */}
      <Modal isOpen={isImagesOpen} onClose={onImagesClose} size="xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            Kelola Gambar - {managingImagesHotel?.HOTEL_NAME}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack align="stretch" spacing={4}>
              {/* Upload Section */}
              <Box>
                <FormControl>
                  <FormLabel>Upload Gambar Baru (Multiple)</FormLabel>
                  <Input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleImageUpload}
                    disabled={uploadingImage}
                  />
                  <Text fontSize="xs" color="gray.500" mt={1}>
                    Format: JPG, PNG, GIF. Maksimal 5MB per file. Bisa upload beberapa file sekaligus.
                  </Text>
                </FormControl>
                {uploadingImage && (
                  <HStack mt={2}>
                    <Spinner size="sm" />
                    <Text fontSize="sm" color="gray.600">Mengupload gambar...</Text>
                  </HStack>
                )}
              </Box>

              <Divider />

              {/* Images List */}
              <Box>
                <Text fontSize="md" fontWeight="600" mb={3}>
                  Daftar Gambar ({hotelImages.length})
                </Text>
                {loadingImages ? (
                  <VStack py={8}>
                    <Spinner size="lg" />
                    <Text color="gray.500">Memuat gambar...</Text>
                  </VStack>
                ) : hotelImages.length === 0 ? (
                  <Text py={8} color="gray.500" textAlign="center">
                    Belum ada gambar untuk hotel ini
                  </Text>
                ) : (
                  <VStack align="stretch" spacing={3}>
                    {hotelImages.map((image) => (
                      <Box
                        key={image.IMAGEHOTEL_ID}
                        p={4}
                        border="1px solid"
                        borderColor="gray.200"
                        borderRadius="8px"
                      >
                        <HStack justify="space-between" align="start">
                          <VStack align="start" spacing={2} flex={1}>
                            <Text fontSize="sm" fontWeight="500">
                              {image.IMAGEHOTEL_NAMEFILE}
                            </Text>
                            <Image
                              src={`/images/hotels/${image.IMAGEHOTEL_NAMEFILE}`}
                              alt={image.IMAGEHOTEL_NAMEFILE || 'Hotel image'}
                              maxH="150px"
                              maxW="200px"
                              objectFit="contain"
                              fallback={
                                <Box
                                  w="200px"
                                  h="150px"
                                  bg="gray.100"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  borderRadius="4px"
                                >
                                  <Text fontSize="xs" color="gray.500">
                                    Gambar tidak ditemukan
                                  </Text>
                                </Box>
                              }
                            />
                          </VStack>
                          <IconButton
                            icon={<FiTrash2 />}
                            size="sm"
                            colorScheme="red"
                            variant="ghost"
                            onClick={() => handleDeleteImageClick(image)}
                            aria-label="Delete Image"
                          />
                        </HStack>
                      </Box>
                    ))}
                  </VStack>
                )}
              </Box>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onImagesClose}>Tutup</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Delete Image Confirmation Dialog */}
      <AlertDialog
        isOpen={isDeleteImageOpen}
        leastDestructiveRef={cancelImageRef}
        onClose={onDeleteImageClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Hapus Gambar
            </AlertDialogHeader>

            <AlertDialogBody>
              Apakah Anda yakin ingin menghapus gambar <strong>{deleteImage?.IMAGEHOTEL_NAMEFILE}</strong>?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelImageRef} onClick={onDeleteImageClose}>
                Batal
              </Button>
              <Button colorScheme="red" onClick={handleDeleteImageConfirm} ml={3}>
                Hapus
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* ========== LOUNGE MODALS ========== */}
      
      {/* Create/Edit Lounge Modal */}
      <Modal 
        isOpen={isLoungeFormOpen} 
        onClose={() => {
          setIsAirportDropdownOpen(false);
          onLoungeFormClose();
        }} 
        size="xl" 
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {editingLounge ? 'Edit Lounge' : 'Tambah Lounge Baru'}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody
            onClick={() => {
              // Close dropdown when clicking outside
              if (isAirportDropdownOpen) {
                setIsAirportDropdownOpen(false);
              }
            }}
          >
            <VStack spacing={4}>
              <FormControl isRequired>
                <FormLabel>Nama Lounge</FormLabel>
                <Input
                  name="LOUNGE_NAME"
                  value={loungeFormData.LOUNGE_NAME}
                  onChange={handleLoungeInputChange}
                  placeholder="Masukkan nama lounge"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Kota</FormLabel>
                <Input
                  name="LOUNGE_CITY"
                  value={loungeFormData.LOUNGE_CITY}
                  onChange={handleLoungeInputChange}
                  placeholder="Masukkan kota"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Terminal</FormLabel>
                <Input
                  name="LOUNGE_TERMINAL"
                  value={loungeFormData.LOUNGE_TERMINAL}
                  onChange={handleLoungeInputChange}
                  placeholder="Masukkan terminal"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Kode Bandara</FormLabel>
                <Box position="relative">
                  <Input
                    value={selectedAirport 
                      ? `${selectedAirport.AIRPORT_CODE} - ${selectedAirport.AIRPORT_NAME} (${selectedAirport.AIRPORT_CITY})`
                      : airportSearchTerm
                    }
                    onChange={(e) => {
                      setAirportSearchTerm(e.target.value);
                      setIsAirportDropdownOpen(true);
                      if (!e.target.value) {
                        setLoungeFormData((prev) => ({
                          ...prev,
                          AIRPORT_CODE: '',
                        }));
                      }
                    }}
                    onFocus={() => setIsAirportDropdownOpen(true)}
                    placeholder="Cari atau pilih kode bandara..."
                    readOnly={!!selectedAirport && !airportSearchTerm}
                    onClick={() => {
                      if (selectedAirport) {
                        setAirportSearchTerm('');
                        setIsAirportDropdownOpen(true);
                      }
                    }}
                  />
                  {isAirportDropdownOpen && (
                    <Box
                      position="absolute"
                      top="100%"
                      left={0}
                      right={0}
                      zIndex={1000}
                      mt={1}
                      bg="white"
                      border="1px solid"
                      borderColor="gray.300"
                      borderRadius="md"
                      boxShadow="lg"
                      maxH="300px"
                      overflowY="auto"
                    >
                      {loadingAirports ? (
                        <Box p={4} textAlign="center">
                          <Spinner size="sm" />
                          <Text mt={2} fontSize="sm" color="gray.500">
                            Memuat data bandara...
                          </Text>
                        </Box>
                      ) : filteredAirports.length === 0 ? (
                        <Box p={4} textAlign="center">
                          <Text fontSize="sm" color="gray.500">
                            {airportSearchTerm ? 'Tidak ada bandara yang ditemukan' : 'Tidak ada data bandara'}
                          </Text>
                        </Box>
                      ) : (
                        <VStack align="stretch" spacing={0} divider={<Divider />}>
                          {filteredAirports.map((airport) => (
                            <Box
                              key={airport.AIRPORT_CODE}
                              p={3}
                              cursor="pointer"
                              _hover={{ bg: 'gray.100' }}
                              onClick={() => handleAirportSelect(airport.AIRPORT_CODE)}
                            >
                              <VStack align="start" spacing={1}>
                                <Text fontWeight="600" fontSize="sm">
                                  {airport.AIRPORT_CODE}
                                </Text>
                                <Text fontSize="xs" color="gray.600">
                                  {airport.AIRPORT_NAME}
                                </Text>
                                <Text fontSize="xs" color="gray.500">
                                  {airport.AIRPORT_CITY}
                                </Text>
                              </VStack>
                            </Box>
                          ))}
                        </VStack>
                      )}
                    </Box>
                  )}
                  {selectedAirport && !isAirportDropdownOpen && (
                    <Button
                      size="xs"
                      variant="ghost"
                      position="absolute"
                      right={2}
                      top="50%"
                      transform="translateY(-50%)"
                      onClick={(e) => {
                        e.stopPropagation();
                        setLoungeFormData((prev) => ({
                          ...prev,
                          AIRPORT_CODE: '',
                        }));
                        setAirportSearchTerm('');
                      }}
                    >
                      ✕
                    </Button>
                  )}
                </Box>
                <Text fontSize="xs" color="gray.500" mt={1}>
                  Ketik untuk mencari bandara berdasarkan kode, nama, atau kota
                </Text>
              </FormControl>

              <FormControl>
                <FormLabel>Publish Rate</FormLabel>
                <Select
                  name="LOUNGE_PUBLISRATE"
                  value={loungeFormData.LOUNGE_PUBLISRATE}
                  onChange={handleLoungeInputChange}
                  placeholder="Pilih publish rate"
                >
                  <option value="1">Active</option>
                  <option value="0">Not Active</option>
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>Harga</FormLabel>
                <Input
                  name="LOUNGE_PRICE"
                  type="number"
                  value={loungeFormData.LOUNGE_PRICE}
                  onChange={handleLoungeInputChange}
                  placeholder="Masukkan harga"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Harga Diskon (Opsional)</FormLabel>
                <Input
                  name="LOUNGE_DISCOUNTPRICE"
                  type="number"
                  value={loungeFormData.LOUNGE_DISCOUNTPRICE}
                  onChange={handleLoungeInputChange}
                  placeholder="Masukkan harga diskon"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Telepon</FormLabel>
                <Input
                  name="LOUNGE_PHONE"
                  value={loungeFormData.LOUNGE_PHONE}
                  onChange={handleLoungeInputChange}
                  placeholder="Masukkan nomor telepon"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Contact Person</FormLabel>
                <Input
                  name="LOUNGE_CONTACTPERSON"
                  value={loungeFormData.LOUNGE_CONTACTPERSON}
                  onChange={handleLoungeInputChange}
                  placeholder="Masukkan contact person"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Email</FormLabel>
                <Input
                  name="LOUNGE_EMAIL"
                  type="email"
                  value={loungeFormData.LOUNGE_EMAIL}
                  onChange={handleLoungeInputChange}
                  placeholder="Masukkan email"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Term & Condition</FormLabel>
                <Textarea
                  name="LOUNGE_TERMCONDITION"
                  value={loungeFormData.LOUNGE_TERMCONDITION}
                  onChange={handleLoungeInputChange}
                  placeholder="Masukkan term & condition"
                  rows={4}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Message</FormLabel>
                <Textarea
                  name="LOUNGE_MSG"
                  value={loungeFormData.LOUNGE_MSG}
                  onChange={handleLoungeInputChange}
                  placeholder="Masukkan message"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Deskripsi</FormLabel>
                <Textarea
                  name="LOUNGE_DESCRIPTION"
                  value={loungeFormData.LOUNGE_DESCRIPTION}
                  onChange={handleLoungeInputChange}
                  placeholder="Masukkan deskripsi"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Status</FormLabel>
                <Select
                  name="LOUNGE_STATUS"
                  value={loungeFormData.LOUNGE_STATUS}
                  onChange={handleLoungeInputChange}
                >
                  <option value="1">Active</option>
                  <option value="0">Not Active</option>
                </Select>
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onLoungeFormClose}>
              Batal
            </Button>
            <Button colorScheme="brand" onClick={handleLoungeSubmit}>
              {editingLounge ? 'Update' : 'Simpan'}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* View Lounge Modal */}
      <Modal isOpen={isLoungeViewOpen} onClose={onLoungeViewClose} size="xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Detail Lounge</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {viewingLounge && (
              <VStack align="stretch" spacing={4}>
                <Box>
                  <Text fontWeight="bold" mb={2}>Nama Lounge</Text>
                  <Text>{viewingLounge.LOUNGE_NAME || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Kota</Text>
                  <Text>{viewingLounge.LOUNGE_CITY || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Terminal</Text>
                  <Text>{viewingLounge.LOUNGE_TERMINAL || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Kode Bandara</Text>
                  <Text>{viewingLounge.AIRPORT_CODE || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Publish Rate</Text>
                  <Badge colorScheme={viewingLounge.LOUNGE_PUBLISRATE === '1' || viewingLounge.LOUNGE_PUBLISRATE === 1 ? 'green' : 'red'}>
                    {viewingLounge.LOUNGE_PUBLISRATE === '1' || viewingLounge.LOUNGE_PUBLISRATE === 1 ? 'Active' : 'Not Active'}
                  </Badge>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Harga</Text>
                  {viewingLounge.LOUNGE_DISCOUNTPRICE ? (
                    <VStack align="start" spacing={1}>
                      <Text style={{ textDecoration: 'line-through', color: '#999' }}>
                        {viewingLounge.LOUNGE_PRICE ? `Rp ${viewingLounge.LOUNGE_PRICE.toLocaleString('id-ID')}` : '-'}
                      </Text>
                      <Text fontWeight="bold" color="#17a2b8">
                        {`Rp ${viewingLounge.LOUNGE_DISCOUNTPRICE.toLocaleString('id-ID')}`}
                      </Text>
                    </VStack>
                  ) : (
                    <Text>{viewingLounge.LOUNGE_PRICE ? `Rp ${viewingLounge.LOUNGE_PRICE.toLocaleString('id-ID')}` : '-'}</Text>
                  )}
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Telepon</Text>
                  <Text>{viewingLounge.LOUNGE_PHONE || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Contact Person</Text>
                  <Text>{viewingLounge.LOUNGE_CONTACTPERSON || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Email</Text>
                  <Text>{viewingLounge.LOUNGE_EMAIL || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Term & Condition</Text>
                  <Text>{viewingLounge.LOUNGE_TERMCONDITION || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Message</Text>
                  <Text>{viewingLounge.LOUNGE_MSG || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Deskripsi</Text>
                  <Text>{viewingLounge.LOUNGE_DESCRIPTION || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Status</Text>
                  <Badge colorScheme={viewingLounge.LOUNGE_STATUS === '1' || viewingLounge.LOUNGE_STATUS === 1 ? 'green' : 'red'}>
                    {viewingLounge.LOUNGE_STATUS === '1' || viewingLounge.LOUNGE_STATUS === 1 ? 'Active' : 'Not Active'}
                  </Badge>
                </Box>
              </VStack>
            )}
          </ModalBody>
          <ModalFooter>
            <Button onClick={onLoungeViewClose}>Tutup</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Delete Lounge Confirmation Dialog */}
      <AlertDialog
        isOpen={isLoungeDeleteOpen}
        leastDestructiveRef={cancelLoungeRef}
        onClose={onLoungeDeleteClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Hapus Lounge
            </AlertDialogHeader>
            <AlertDialogBody>
              Apakah Anda yakin ingin menghapus lounge <strong>{deleteLounge?.LOUNGE_NAME}</strong>?
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelLoungeRef} onClick={onLoungeDeleteClose}>
                Batal
              </Button>
              <Button colorScheme="red" onClick={handleLoungeDeleteConfirm} ml={3}>
                Hapus
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* Manage Lounge Images Modal */}
      <Modal isOpen={isLoungeImagesOpen} onClose={onLoungeImagesClose} size="xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            Kelola Gambar - {managingImagesLounge?.LOUNGE_NAME}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack align="stretch" spacing={4}>
              <Box>
                <FormControl>
                  <FormLabel>Upload Gambar Baru (Multiple)</FormLabel>
                  <Input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleLoungeImageUpload}
                    disabled={uploadingLoungeImage}
                  />
                  <Text fontSize="xs" color="gray.500" mt={1}>
                    Format: JPG, PNG, GIF. Maksimal 5MB per file. Bisa upload beberapa file sekaligus.
                  </Text>
                </FormControl>
                {uploadingLoungeImage && (
                  <HStack mt={2}>
                    <Spinner size="sm" />
                    <Text fontSize="sm" color="gray.600">Mengupload gambar...</Text>
                  </HStack>
                )}
              </Box>

              <Divider />

              <Box>
                <Text fontSize="md" fontWeight="600" mb={3}>
                  Daftar Gambar ({loungeImages.length})
                </Text>
                {loadingLoungeImages ? (
                  <VStack py={8}>
                    <Spinner size="lg" />
                    <Text color="gray.500">Memuat gambar...</Text>
                  </VStack>
                ) : loungeImages.length === 0 ? (
                  <Text py={8} color="gray.500" textAlign="center">
                    Belum ada gambar untuk lounge ini
                  </Text>
                ) : (
                  <VStack align="stretch" spacing={3}>
                    {loungeImages.map((image) => (
                      <Box
                        key={image.IMAGELOUNGE_ID}
                        p={4}
                        border="1px solid"
                        borderColor="gray.200"
                        borderRadius="8px"
                      >
                        <HStack justify="space-between" align="start">
                          <VStack align="start" spacing={2} flex={1}>
                            <Text fontSize="sm" fontWeight="500">
                              {image.IMAGELOUNGE_NAME || image.IMAGELOUNGE_FILE || 'Image'}
                            </Text>
                            <Image
                              src={`/images/lounges/${image.IMAGELOUNGE_FILE}`}
                              alt={image.IMAGELOUNGE_NAME || 'Lounge image'}
                              maxH="150px"
                              maxW="200px"
                              objectFit="contain"
                              fallback={
                                <Box
                                  w="200px"
                                  h="150px"
                                  bg="gray.100"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  borderRadius="4px"
                                >
                                  <Text fontSize="xs" color="gray.500">
                                    Gambar tidak ditemukan
                                  </Text>
                                </Box>
                              }
                            />
                          </VStack>
                          <IconButton
                            icon={<FiTrash2 />}
                            size="sm"
                            colorScheme="red"
                            variant="ghost"
                            onClick={() => handleDeleteLoungeImageClick(image)}
                            aria-label="Delete Image"
                          />
                        </HStack>
                      </Box>
                    ))}
                  </VStack>
                )}
              </Box>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onLoungeImagesClose}>Tutup</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Delete Lounge Image Confirmation Dialog */}
      <AlertDialog
        isOpen={isDeleteLoungeImageOpen}
        leastDestructiveRef={cancelLoungeImageRef}
        onClose={onDeleteLoungeImageClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Hapus Gambar
            </AlertDialogHeader>
            <AlertDialogBody>
              Apakah Anda yakin ingin menghapus gambar <strong>{deleteLoungeImage?.IMAGELOUNGE_NAME || deleteLoungeImage?.IMAGELOUNGE_FILE}</strong>?
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelLoungeImageRef} onClick={onDeleteLoungeImageClose}>
                Batal
              </Button>
              <Button colorScheme="red" onClick={handleDeleteLoungeImageConfirm} ml={3}>
                Hapus
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* ========== CONCIERGE MODALS ========== */}
      
      {/* Create/Edit Concierge Modal */}
      <Modal 
        isOpen={isConciergeFormOpen} 
        onClose={onConciergeFormClose} 
        size="xl" 
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {editingConcierge ? 'Edit Concierge' : 'Tambah Concierge Baru'}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4}>
              <FormControl isRequired>
                <FormLabel>Nama Concierge</FormLabel>
                <Input
                  name="CONCIERGE_NAME"
                  value={conciergeFormData.CONCIERGE_NAME}
                  onChange={handleConciergeInputChange}
                  placeholder="Masukkan nama concierge"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Tipe</FormLabel>
                <Input
                  name="CONCIERGE_TYPE"
                  value={conciergeFormData.CONCIERGE_TYPE}
                  onChange={handleConciergeInputChange}
                  placeholder="Masukkan tipe concierge"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Lokasi</FormLabel>
                <Input
                  name="CONCIERGE_LOCATION"
                  value={conciergeFormData.CONCIERGE_LOCATION}
                  onChange={handleConciergeInputChange}
                  placeholder="Masukkan lokasi"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Layanan</FormLabel>
                <Input
                  name="CONCIERGE_SERVICES"
                  value={conciergeFormData.CONCIERGE_SERVICES}
                  onChange={handleConciergeInputChange}
                  placeholder="Masukkan layanan"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Deskripsi</FormLabel>
                <Textarea
                  name="CONCIERGE_DESCRIPTION"
                  value={conciergeFormData.CONCIERGE_DESCRIPTION}
                  onChange={handleConciergeInputChange}
                  placeholder="Masukkan deskripsi"
                  rows={4}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Publish Rate</FormLabel>
                <Select
                  name="CONCIERGE_PUBLISHRATE"
                  value={conciergeFormData.CONCIERGE_PUBLISHRATE}
                  onChange={handleConciergeInputChange}
                  placeholder="Pilih publish rate"
                >
                  <option value="1">Active</option>
                  <option value="0">Not Active</option>
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>Harga</FormLabel>
                <Input
                  name="CONCIERGE_PRICE"
                  value={conciergeFormData.CONCIERGE_PRICE}
                  onChange={handleConciergeInputChange}
                  placeholder="Masukkan harga"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Harga Diskon (Opsional)</FormLabel>
                <Input
                  name="CONCIERGE_DISCOUNTPRICE"
                  value={conciergeFormData.CONCIERGE_DISCOUNTPRICE}
                  onChange={handleConciergeInputChange}
                  placeholder="Masukkan harga diskon"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Airport Code</FormLabel>
                <Select
                  name="AIRPORT_CODE"
                  value={conciergeFormData.AIRPORT_CODE}
                  onChange={handleConciergeInputChange}
                  placeholder="Pilih airport code"
                >
                  {airports
                    .filter(airport => 
                      !airportSearchTerm || 
                      (airport.AIRPORT_CODE && airport.AIRPORT_CODE.toLowerCase().includes(airportSearchTerm.toLowerCase())) ||
                      (airport.AIRPORT_NAME && airport.AIRPORT_NAME.toLowerCase().includes(airportSearchTerm.toLowerCase()))
                    )
                    .map((airport) => (
                      <option key={airport.AIRPORT_ID} value={airport.AIRPORT_CODE}>
                        {airport.AIRPORT_CODE} - {airport.AIRPORT_NAME} {airport.AIRPORT_CITY ? `(${airport.AIRPORT_CITY})` : ''}
                      </option>
                    ))}
                </Select>
              </FormControl>

              <HStack spacing={4} align="flex-start" width="100%">
                <FormControl flex={1} width="100%">
                  <FormLabel 
                    height="56px" 
                    display="flex" 
                    alignItems="flex-start" 
                    paddingTop="8px" 
                    marginBottom="8px"
                    lineHeight="1.5"
                  >
                    Routes Type
                  </FormLabel>
                  <Select
                    name="ROUTES_TYPE"
                    value={conciergeFormData.ROUTES_TYPE}
                    onChange={handleConciergeInputChange}
                    placeholder="Pilih routes type"
                    width="100%"
                  >
                    <option value="">-- Pilih Routes Type --</option>
                    <option value="DOM">DOM - Domestik</option>
                    <option value="INT">INT - International</option>
                  </Select>
                </FormControl>

                <FormControl flex={1} width="100%">
                  <FormLabel 
                    height="56px" 
                    display="flex" 
                    alignItems="flex-start" 
                    paddingTop="8px" 
                    marginBottom="8px"
                    lineHeight="1.5"
                  >
                    Routes Type To (untuk Transfer Flight)
                  </FormLabel>
                  <Select
                    name="ROUTES_TYPETO"
                    value={conciergeFormData.ROUTES_TYPETO}
                    onChange={handleConciergeInputChange}
                    placeholder="Pilih routes type to"
                    width="100%"
                  >
                    <option value="">-- Pilih Routes Type To --</option>
                    <option value="DOM">DOM - Domestik</option>
                    <option value="INT">INT - International</option>
                  </Select>
                </FormControl>
              </HStack>

              <FormControl>
                <FormLabel>Flight Type (untuk Meet & Greet)</FormLabel>
                <Select
                  name="FLIGHT_TYPE"
                  value={conciergeFormData.FLIGHT_TYPE}
                  onChange={handleConciergeInputChange}
                  placeholder="Pilih flight type"
                >
                  <option value="">-- Pilih Flight Type --</option>
                  <option value="DEP">DEP - Departure</option>
                  <option value="ARR">ARR - Arrival</option>
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>Telepon</FormLabel>
                <Input
                  name="CONCIERGE_PHONE"
                  value={conciergeFormData.CONCIERGE_PHONE}
                  onChange={handleConciergeInputChange}
                  placeholder="Masukkan nomor telepon"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Contact Person</FormLabel>
                <Input
                  name="CONCIERGE_CONTACTPERSON"
                  value={conciergeFormData.CONCIERGE_CONTACTPERSON}
                  onChange={handleConciergeInputChange}
                  placeholder="Masukkan contact person"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Email</FormLabel>
                <Input
                  name="CONCIERGE_EMAIL"
                  type="email"
                  value={conciergeFormData.CONCIERGE_EMAIL}
                  onChange={handleConciergeInputChange}
                  placeholder="Masukkan email"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Term & Condition</FormLabel>
                <Textarea
                  name="CONCIERGE_TERMCONDITION"
                  value={conciergeFormData.CONCIERGE_TERMCONDITION}
                  onChange={handleConciergeInputChange}
                  placeholder="Masukkan term & condition"
                  rows={4}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Message</FormLabel>
                <Textarea
                  name="CONCIERGE_MSG"
                  value={conciergeFormData.CONCIERGE_MSG}
                  onChange={handleConciergeInputChange}
                  placeholder="Masukkan message"
                  rows={4}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Status</FormLabel>
                <Select
                  name="CONCIERGE_STATUS"
                  value={conciergeFormData.CONCIERGE_STATUS}
                  onChange={handleConciergeInputChange}
                >
                  <option value="1">Active</option>
                  <option value="0">Not Active</option>
                </Select>
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onConciergeFormClose}>
              Batal
            </Button>
            <Button colorScheme="pink" onClick={handleConciergeSubmit}>
              {editingConcierge ? 'Update' : 'Simpan'}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* View Concierge Modal */}
      <Modal isOpen={isConciergeViewOpen} onClose={onConciergeViewClose} size="xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Detail Concierge</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {viewingConcierge && (
              <VStack align="stretch" spacing={4}>
                <Box>
                  <Text fontWeight="bold" mb={2}>Nama Concierge</Text>
                  <Text>{viewingConcierge.CONCIERGE_NAME || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Tipe</Text>
                  <Text>{viewingConcierge.CONCIERGE_TYPE || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Lokasi</Text>
                  <Text>{viewingConcierge.CONCIERGE_LOCATION || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Layanan</Text>
                  <Text>{viewingConcierge.CONCIERGE_SERVICES || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Deskripsi</Text>
                  <Text>{viewingConcierge.CONCIERGE_DESCRIPTION || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Publish Rate</Text>
                  <Badge colorScheme={viewingConcierge.CONCIERGE_PUBLISHRATE === '1' || viewingConcierge.CONCIERGE_PUBLISHRATE === 1 ? 'green' : 'red'}>
                    {viewingConcierge.CONCIERGE_PUBLISHRATE === '1' || viewingConcierge.CONCIERGE_PUBLISHRATE === 1 ? 'Active' : 'Not Active'}
                  </Badge>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Harga</Text>
                  {viewingConcierge.CONCIERGE_DISCOUNTPRICE ? (
                    <VStack align="start" spacing={1}>
                      <Text style={{ textDecoration: 'line-through', color: '#999' }}>
                        {viewingConcierge.CONCIERGE_PRICE ? formatRupiah(viewingConcierge.CONCIERGE_PRICE) : '-'}
                      </Text>
                      <Text fontWeight="bold" color="red.500">
                        {formatRupiah(viewingConcierge.CONCIERGE_DISCOUNTPRICE)}
                      </Text>
                    </VStack>
                  ) : (
                    <Text>{viewingConcierge.CONCIERGE_PRICE ? formatRupiah(viewingConcierge.CONCIERGE_PRICE) : '-'}</Text>
                  )}
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Airport</Text>
                  <Text>
                    {viewingConcierge.AIRPORT_CODE || '-'}
                    {viewingConcierge.AIRPORT_NAME && ` - ${viewingConcierge.AIRPORT_NAME}`}
                    {viewingConcierge.AIRPORT_CITY && ` (${viewingConcierge.AIRPORT_CITY})`}
                  </Text>
                </Box>
                <HStack spacing={4} align="flex-start" width="100%">
                  <Box flex={1} width="100%">
                    <Text fontWeight="bold" mb={2}>Routes Type</Text>
                    <Text>
                      {viewingConcierge.ROUTES_TYPE 
                        ? `${viewingConcierge.ROUTES_TYPE} - ${viewingConcierge.ROUTES_TYPE === 'DOM' ? 'Domestik' : viewingConcierge.ROUTES_TYPE === 'INT' ? 'International' : viewingConcierge.ROUTES_TYPE}`
                        : '-'
                      }
                    </Text>
                  </Box>
                  <Box flex={1} width="100%">
                    <Text fontWeight="bold" mb={2}>Routes Type To</Text>
                    <Text>
                      {viewingConcierge.ROUTES_TYPETO 
                        ? `${viewingConcierge.ROUTES_TYPETO} - ${viewingConcierge.ROUTES_TYPETO === 'DOM' ? 'Domestik' : viewingConcierge.ROUTES_TYPETO === 'INT' ? 'International' : viewingConcierge.ROUTES_TYPETO}`
                        : '-'
                      }
                    </Text>
                  </Box>
                </HStack>
                <Box>
                  <Text fontWeight="bold" mb={2}>Flight Type</Text>
                  <Text>
                    {viewingConcierge.FLIGHT_TYPE 
                      ? `${viewingConcierge.FLIGHT_TYPE} - ${viewingConcierge.FLIGHT_TYPE === 'DEP' ? 'Departure' : viewingConcierge.FLIGHT_TYPE === 'ARR' ? 'Arrival' : viewingConcierge.FLIGHT_TYPE}`
                      : '-'
                    }
                  </Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Telepon</Text>
                  <Text>{viewingConcierge.CONCIERGE_PHONE || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Contact Person</Text>
                  <Text>{viewingConcierge.CONCIERGE_CONTACTPERSON || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Email</Text>
                  <Text>{viewingConcierge.CONCIERGE_EMAIL || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Term & Condition</Text>
                  <Text>{viewingConcierge.CONCIERGE_TERMCONDITION || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Message</Text>
                  <Text>{viewingConcierge.CONCIERGE_MSG || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Status</Text>
                  <Badge colorScheme={viewingConcierge.CONCIERGE_STATUS === '1' || viewingConcierge.CONCIERGE_STATUS === 1 ? 'green' : 'red'}>
                    {viewingConcierge.CONCIERGE_STATUS === '1' || viewingConcierge.CONCIERGE_STATUS === 1 ? 'Active' : 'Not Active'}
                  </Badge>
                </Box>
              </VStack>
            )}
          </ModalBody>
          <ModalFooter>
            <Button onClick={onConciergeViewClose}>Tutup</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Delete Concierge Confirmation Dialog */}
      <AlertDialog
        isOpen={isConciergeDeleteOpen}
        leastDestructiveRef={cancelConciergeRef}
        onClose={onConciergeDeleteClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Hapus Concierge
            </AlertDialogHeader>
            <AlertDialogBody>
              Apakah Anda yakin ingin menghapus concierge <strong>{deleteConcierge?.CONCIERGE_NAME}</strong>?
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelConciergeRef} onClick={onConciergeDeleteClose}>
                Batal
              </Button>
              <Button colorScheme="red" onClick={handleConciergeDeleteConfirm} ml={3}>
                Hapus
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* Manage Concierge Images Modal */}
      <Modal isOpen={isConciergeImagesOpen} onClose={onConciergeImagesClose} size="xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            Kelola Gambar - {managingImagesConcierge?.CONCIERGE_NAME}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack align="stretch" spacing={4}>
              {/* Upload Section */}
              <Box>
                <FormControl>
                  <FormLabel>Upload Gambar Baru (Multiple)</FormLabel>
                  <Input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleConciergeImageUpload}
                    disabled={uploadingConciergeImage}
                  />
                  <Text fontSize="xs" color="gray.500" mt={1}>
                    Format: JPG, PNG, GIF. Maksimal 5MB per file. Bisa upload beberapa file sekaligus.
                  </Text>
                </FormControl>
                {uploadingConciergeImage && (
                  <HStack mt={2}>
                    <Spinner size="sm" />
                    <Text fontSize="sm" color="gray.600">Mengupload gambar...</Text>
                  </HStack>
                )}
              </Box>

              <Divider />

              {/* Images List */}
              <Box>
                <Text fontSize="md" fontWeight="600" mb={3}>
                  Daftar Gambar ({conciergeImages.length})
                </Text>
                {loadingConciergeImages ? (
                  <VStack py={8}>
                    <Spinner size="lg" />
                    <Text color="gray.500">Memuat gambar...</Text>
                  </VStack>
                ) : conciergeImages.length === 0 ? (
                  <Text py={8} color="gray.500" textAlign="center">
                    Belum ada gambar untuk concierge ini
                  </Text>
                ) : (
                  <VStack align="stretch" spacing={3}>
                    {conciergeImages.map((image) => (
                      <Box
                        key={image.IMAGECONCIERGE_ID}
                        p={4}
                        border="1px solid"
                        borderColor="gray.200"
                        borderRadius="8px"
                      >
                        <HStack justify="space-between" align="start">
                          <VStack align="start" spacing={2} flex={1}>
                            <Text fontSize="sm" fontWeight="500">
                              {image.IMAGECONCIERGE_NAME || image.IMAGECONCIERGE_FILE || 'Image'}
                            </Text>
                            <Image
                              src={`/images/concierges/${image.IMAGECONCIERGE_FILE}`}
                              alt={image.IMAGECONCIERGE_NAME || 'Concierge image'}
                              maxH="150px"
                              maxW="200px"
                              objectFit="contain"
                              fallback={
                                <Box
                                  w="200px"
                                  h="150px"
                                  bg="gray.100"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  borderRadius="4px"
                                >
                                  <Text fontSize="xs" color="gray.500">
                                    Gambar tidak ditemukan
                                  </Text>
                                </Box>
                              }
                            />
                          </VStack>
                          <IconButton
                            icon={<FiTrash2 />}
                            size="sm"
                            colorScheme="red"
                            variant="ghost"
                            onClick={() => handleDeleteConciergeImageClick(image)}
                            aria-label="Delete Image"
                          />
                        </HStack>
                      </Box>
                    ))}
                  </VStack>
                )}
              </Box>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onConciergeImagesClose}>Tutup</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Delete Concierge Image Confirmation Dialog */}
      <AlertDialog
        isOpen={isDeleteConciergeImageOpen}
        leastDestructiveRef={cancelConciergeImageRef}
        onClose={onDeleteConciergeImageClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Hapus Gambar
            </AlertDialogHeader>
            <AlertDialogBody>
              Apakah Anda yakin ingin menghapus gambar <strong>{deleteConciergeImage?.IMAGECONCIERGE_NAME || deleteConciergeImage?.IMAGECONCIERGE_FILE}</strong>?
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelConciergeImageRef} onClick={onDeleteConciergeImageClose}>
                Batal
              </Button>
              <Button colorScheme="red" onClick={handleDeleteConciergeImageConfirm} ml={3}>
                Hapus
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* ========== BAGGAGE MODALS ========== */}

      {/* Create/Edit Baggage Modal */}
      <Modal isOpen={isBaggageFormOpen} onClose={onBaggageFormClose} size="xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {editingBaggage ? 'Edit Baggage Service' : 'Tambah Baggage Service Baru'}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4}>
              <FormControl isRequired>
                <FormLabel>Nama Baggage</FormLabel>
                <Input
                  name="BAGGAGE_NAME"
                  value={baggageFormData.BAGGAGE_NAME}
                  onChange={handleBaggageInputChange}
                  placeholder="Masukkan nama baggage service"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Lokasi (Airport Code)</FormLabel>
                <Box position="relative">
                  <Input
                    value={selectedBaggageAirport 
                      ? `${selectedBaggageAirport.AIRPORT_CODE} - ${selectedBaggageAirport.AIRPORT_NAME} (${selectedBaggageAirport.AIRPORT_CITY})`
                      : airportSearchTerm
                    }
                    onChange={(e) => {
                      setAirportSearchTerm(e.target.value);
                      setIsAirportDropdownOpen(true);
                      if (!e.target.value) {
                        setBaggageFormData((prev) => ({
                          ...prev,
                          BAGGAGE_LOCATION: '',
                        }));
                      }
                    }}
                    onFocus={() => setIsAirportDropdownOpen(true)}
                    placeholder="Cari atau pilih kode bandara..."
                    readOnly={!!selectedBaggageAirport && !airportSearchTerm}
                    onClick={() => {
                      if (selectedBaggageAirport) {
                        setAirportSearchTerm('');
                        setIsAirportDropdownOpen(true);
                      }
                    }}
                  />
                  {isAirportDropdownOpen && (
                    <Box
                      position="absolute"
                      top="100%"
                      left={0}
                      right={0}
                      bg="white"
                      border="1px solid"
                      borderColor="gray.300"
                      borderRadius="md"
                      mt={1}
                      maxH="200px"
                      overflowY="auto"
                      zIndex={1000}
                      boxShadow="lg"
                    >
                      {filteredAirports.length > 0 ? (
                        <VStack align="stretch" spacing={0}>
                          {filteredAirports.map((airport) => (
                            <Box
                              key={airport.AIRPORT_CODE}
                              p={2}
                              _hover={{ bg: 'gray.100', cursor: 'pointer' }}
                              onClick={() => {
                                setBaggageFormData((prev) => ({
                                  ...prev,
                                  BAGGAGE_LOCATION: airport.AIRPORT_CODE,
                                }));
                                setAirportSearchTerm('');
                                setIsAirportDropdownOpen(false);
                              }}
                            >
                              <VStack align="start" spacing={0}>
                                <Text fontWeight="600" fontSize="sm">
                                  {airport.AIRPORT_CODE}
                                </Text>
                                <Text fontSize="xs" color="gray.600">
                                  {airport.AIRPORT_NAME}
                                </Text>
                                <Text fontSize="xs" color="gray.500">
                                  {airport.AIRPORT_CITY}
                                </Text>
                              </VStack>
                            </Box>
                          ))}
                        </VStack>
                      ) : (
                        <Box p={3} textAlign="center" color="gray.500">
                          Tidak ada bandara ditemukan
                        </Box>
                      )}
                    </Box>
                  )}
                  {baggageFormData.BAGGAGE_LOCATION && !isAirportDropdownOpen && (
                    <Button
                      size="xs"
                      variant="ghost"
                      position="absolute"
                      right={2}
                      top="50%"
                      transform="translateY(-50%)"
                      onClick={(e) => {
                        e.stopPropagation();
                        setBaggageFormData((prev) => ({
                          ...prev,
                          BAGGAGE_LOCATION: '',
                        }));
                        setAirportSearchTerm('');
                      }}
                    >
                      ✕
                    </Button>
                  )}
                </Box>
                <Text fontSize="xs" color="gray.500" mt={1}>
                  Ketik untuk mencari bandara berdasarkan kode, nama, atau kota
                </Text>
              </FormControl>

              <FormControl>
                <FormLabel>Area</FormLabel>
                <Input
                  name="BAGGAGE_AREA"
                  value={baggageFormData.BAGGAGE_AREA}
                  onChange={handleBaggageInputChange}
                  placeholder="Masukkan area"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Deskripsi</FormLabel>
                <Textarea
                  name="BAGGAGE_DESCRIPTION"
                  value={baggageFormData.BAGGAGE_DESCRIPTION}
                  onChange={handleBaggageInputChange}
                  placeholder="Masukkan deskripsi"
                  rows={4}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Publish Rate</FormLabel>
                <Select
                  name="BAGGAGE_PUBLISHRATE"
                  value={baggageFormData.BAGGAGE_PUBLISHRATE}
                  onChange={handleBaggageInputChange}
                  placeholder="Pilih publish rate"
                >
                  <option value="1">Active</option>
                  <option value="0">Not Active</option>
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>Harga</FormLabel>
                <Input
                  name="BAGGAGE_PRICE"
                  type="number"
                  value={baggageFormData.BAGGAGE_PRICE}
                  onChange={handleBaggageInputChange}
                  placeholder="Masukkan harga"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Harga Diskon (Opsional)</FormLabel>
                <Input
                  name="BAGGAGE_DISCOUNTPRICE"
                  type="number"
                  value={baggageFormData.BAGGAGE_DISCOUNTPRICE}
                  onChange={handleBaggageInputChange}
                  placeholder="Masukkan harga diskon"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Telepon</FormLabel>
                <Input
                  name="BAGGAGE_PHONE"
                  value={baggageFormData.BAGGAGE_PHONE}
                  onChange={handleBaggageInputChange}
                  placeholder="Masukkan nomor telepon"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Contact Person</FormLabel>
                <Input
                  name="BAGGAGE_CONTACTPERSON"
                  value={baggageFormData.BAGGAGE_CONTACTPERSON}
                  onChange={handleBaggageInputChange}
                  placeholder="Masukkan contact person"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Email</FormLabel>
                <Input
                  name="BAGGAGE_EMAIL"
                  type="email"
                  value={baggageFormData.BAGGAGE_EMAIL}
                  onChange={handleBaggageInputChange}
                  placeholder="Masukkan email"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Term & Condition</FormLabel>
                <Textarea
                  name="BAGGAGE_TERMCONDITION"
                  value={baggageFormData.BAGGAGE_TERMCONDITION}
                  onChange={handleBaggageInputChange}
                  placeholder="Masukkan term & condition"
                  rows={4}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Message</FormLabel>
                <Textarea
                  name="BAGGAGE_MSG"
                  value={baggageFormData.BAGGAGE_MSG}
                  onChange={handleBaggageInputChange}
                  placeholder="Masukkan message"
                  rows={4}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Status</FormLabel>
                <Select
                  name="BAGGAGE_STATUS"
                  value={baggageFormData.BAGGAGE_STATUS}
                  onChange={handleBaggageInputChange}
                >
                  <option value="1">Active</option>
                  <option value="0">Not Active</option>
                </Select>
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onBaggageFormClose}>
              Batal
            </Button>
            <Button colorScheme="purple" onClick={handleBaggageSubmit}>
              {editingBaggage ? 'Update' : 'Simpan'}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* View Baggage Modal */}
      <Modal isOpen={isBaggageViewOpen} onClose={onBaggageViewClose} size="xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Detail Baggage Service</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {viewingBaggage && (
              <VStack align="stretch" spacing={4}>
                <Box>
                  <Text fontWeight="bold" mb={2}>Nama Baggage</Text>
                  <Text>{viewingBaggage.BAGGAGE_NAME || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Lokasi (Airport Code)</Text>
                  <Text>{viewingBaggage.BAGGAGE_LOCATION || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Area</Text>
                  <Text>{viewingBaggage.BAGGAGE_AREA || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Deskripsi</Text>
                  <Text>{viewingBaggage.BAGGAGE_DESCRIPTION || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Publish Rate</Text>
                  <Badge colorScheme={viewingBaggage.BAGGAGE_PUBLISHRATE === '1' || viewingBaggage.BAGGAGE_PUBLISHRATE === 1 ? 'green' : 'red'}>
                    {viewingBaggage.BAGGAGE_PUBLISHRATE === '1' || viewingBaggage.BAGGAGE_PUBLISHRATE === 1 ? 'Active' : 'Not Active'}
                  </Badge>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Harga</Text>
                  {viewingBaggage.BAGGAGE_DISCOUNTPRICE ? (
                    <VStack align="start" spacing={1}>
                      <Text style={{ textDecoration: 'line-through', color: '#999' }}>
                        {viewingBaggage.BAGGAGE_PRICE ? `Rp ${parseFloat(viewingBaggage.BAGGAGE_PRICE).toLocaleString('id-ID')}` : '-'}
                      </Text>
                      <Text fontWeight="bold" color="red.500">
                        {viewingBaggage.BAGGAGE_DISCOUNTPRICE ? `Rp ${parseFloat(viewingBaggage.BAGGAGE_DISCOUNTPRICE).toLocaleString('id-ID')}` : '-'}
                      </Text>
                    </VStack>
                  ) : (
                    <Text>{viewingBaggage.BAGGAGE_PRICE ? `Rp ${parseFloat(viewingBaggage.BAGGAGE_PRICE).toLocaleString('id-ID')}` : '-'}</Text>
                  )}
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Telepon</Text>
                  <Text>{viewingBaggage.BAGGAGE_PHONE || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Contact Person</Text>
                  <Text>{viewingBaggage.BAGGAGE_CONTACTPERSON || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Email</Text>
                  <Text>{viewingBaggage.BAGGAGE_EMAIL || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Term & Condition</Text>
                  <Text>{viewingBaggage.BAGGAGE_TERMCONDITION || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Message</Text>
                  <Text>{viewingBaggage.BAGGAGE_MSG || '-'}</Text>
                </Box>
                <Box>
                  <Text fontWeight="bold" mb={2}>Status</Text>
                  <Badge colorScheme={viewingBaggage.BAGGAGE_STATUS === '1' || viewingBaggage.BAGGAGE_STATUS === 1 ? 'green' : 'red'}>
                    {viewingBaggage.BAGGAGE_STATUS === '1' || viewingBaggage.BAGGAGE_STATUS === 1 ? 'Active' : 'Not Active'}
                  </Badge>
                </Box>
              </VStack>
            )}
          </ModalBody>
          <ModalFooter>
            <Button onClick={onBaggageViewClose}>Tutup</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Delete Baggage Confirmation Dialog */}
      <AlertDialog
        isOpen={isBaggageDeleteOpen}
        leastDestructiveRef={cancelBaggageRef}
        onClose={onBaggageDeleteClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Hapus Baggage Service
            </AlertDialogHeader>
            <AlertDialogBody>
              Apakah Anda yakin ingin menghapus baggage service <strong>{deleteBaggage?.BAGGAGE_NAME}</strong>?
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelBaggageRef} onClick={onBaggageDeleteClose}>
                Batal
              </Button>
              <Button colorScheme="red" onClick={handleBaggageDeleteConfirm} ml={3}>
                Hapus
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* Manage Baggage Images Modal */}
      <Modal isOpen={isBaggageImagesOpen} onClose={onBaggageImagesClose} size="xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Kelola Gambar - {managingImagesBaggage?.BAGGAGE_NAME || 'Baggage Service'}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack align="stretch" spacing={4}>
              {/* Upload Section */}
              <Box>
                <Text fontWeight="600" mb={2}>Upload Gambar</Text>
                <Input
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={handleBaggageImageUpload}
                  disabled={uploadingBaggageImage}
                />
                {uploadingBaggageImage && (
                  <Text fontSize="sm" color="blue.500" mt={2}>
                    Mengupload gambar...
                  </Text>
                )}
              </Box>

              <Divider />

              {/* Images List */}
              <Box>
                <Text fontWeight="600" mb={2}>Daftar Gambar</Text>
                {loadingBaggageImages ? (
                  <Box textAlign="center" py={8}>
                    <Spinner size="lg" />
                  </Box>
                ) : baggageImages.length === 0 ? (
                  <Box textAlign="center" py={8} color="gray.500">
                    Belum ada gambar
                  </Box>
                ) : (
                  <VStack align="stretch" spacing={3}>
                    {baggageImages.map((image) => (
                      <Box
                        key={image.IMAGEBAGGAGE_ID}
                        p={4}
                        border="1px solid"
                        borderColor="gray.200"
                        borderRadius="md"
                      >
                        <HStack spacing={4} align="center">
                          <Image
                            src={`/images/baggages/${image.IMAGEBAGGAGE_FILE}`}
                            alt={image.IMAGEBAGGAGE_NAME}
                            boxSize="80px"
                            objectFit="cover"
                            borderRadius="md"
                            fallbackSrc="https://via.placeholder.com/80"
                          />
                          <VStack align="start" flex={1} spacing={1}>
                            <Text fontWeight="600" fontSize="sm">
                              {image.IMAGEBAGGAGE_NAME || image.IMAGEBAGGAGE_FILE}
                            </Text>
                            <Text fontSize="xs" color="gray.500">
                              {image.IMAGEBAGGAGE_FILE}
                            </Text>
                          </VStack>
                          <IconButton
                            icon={<FiTrash2 />}
                            size="sm"
                            colorScheme="red"
                            variant="ghost"
                            onClick={() => handleDeleteBaggageImageClick(image)}
                            aria-label="Delete Image"
                          />
                        </HStack>
                      </Box>
                    ))}
                  </VStack>
                )}
              </Box>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onBaggageImagesClose}>Tutup</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Delete Baggage Image Confirmation Dialog */}
      <AlertDialog
        isOpen={isDeleteBaggageImageOpen}
        leastDestructiveRef={cancelBaggageImageRef}
        onClose={onDeleteBaggageImageClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Hapus Gambar
            </AlertDialogHeader>
            <AlertDialogBody>
              Apakah Anda yakin ingin menghapus gambar <strong>{deleteBaggageImage?.IMAGEBAGGAGE_NAME || deleteBaggageImage?.IMAGEBAGGAGE_FILE}</strong>?
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelBaggageImageRef} onClick={onDeleteBaggageImageClose}>
                Batal
              </Button>
              <Button colorScheme="red" onClick={handleDeleteBaggageImageConfirm} ml={3}>
                Hapus
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};

export default AviationServices;
